<template>
  <v-app id="inspire">
    <Header type="search" @changeClient="fetchFeedCustom($event)" @changeClient4="fetchFeedCustom4($event)"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10" style="margin-bottom:50px;" v-if="visitorDesktop && visitorDesktop.client">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Рабочий стол</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен /</span> Рабочий стол</div>
                </div>
                <v-skeleton-loader
                  v-if="isLoadingDesktop"
                  type="actions"
                >
                </v-skeleton-loader>
                <div v-else class="d-flex align-center">

                  <div style="width:400px;     background: white;
                    padding: 10px;
                    border-radius: 10px;">
                    <div v-if="visitorDesktop.client && visitorDesktop.client.fines">
                      
                      <!-- <span v-if="visitorDesktop.client.fines.description.split('время задержки:')[1]">Превышение: {{visitorDesktop.client.fines.description.split('время задержки:')[1]}}</span> -->
                      <span v-if="visitorDesktop.client.fines.fines && visitorDesktop.client.fines.fines[0] && visitorDesktop.client.fines.fines[0].service_number_minutes">Превышение: {{visitorDesktop.client.fines.fines[0].service_number_minutes}} мин., сумма штрафа: {{visitorDesktop.client.fines.fines[0].service_total}} руб.</span>
                      <span v-else>Нет штрафов для оплаты.</span>
                    </div>
                  </div>

                  <v-btn
                  v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.client_id"
                      :to="{ name: 'Sale', params: {client: visitorDesktop.client, buy_id: null, type: 'new', for: 'client', deal: null} }"
                      class="sale-button"
                  >
                    Продажа
                  </v-btn>
                  <v-btn
                      v-else
                      class="sale-button"
                  >
                    Продажа
                  </v-btn>

                  <v-btn
                  v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.client_id"
                      :to="{ name: 'Return', params: {client: visitorDesktop.client} }"
                      class="return-button"
                  >
                    Возврат
                  </v-btn>
                  <v-btn
                      v-else
                      class="return-button"
                  >
                    Возврат
                  </v-btn>
                  <v-btn
                      class="exit-button"
                      @click="exitButton"
                  >
                    <v-icon
                        dark
                        right
                        small
                        class="mr-2"
                    >
                      mdi-exit-to-app
                    </v-icon>
                    {{ exitButtonText }}
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-skeleton-loader
                    v-if="isLoadingDesktop"
                    type="card-avatar, actions"
                >
                </v-skeleton-loader>
                <template v-else>
                  <v-sheet rounded="lg" class="card rounded-b-0" style="border-bottom: 1px solid #E0E0E0;">
                    <div class="edit-avatar">
                      <div class="user-avatar">
                        <img
                            :src="visitorDesktop.client.photo ? visitorDesktop.client.photo : '/playground_assets/mediumcamera3282-238l.svg'"
                            :style="visitorDesktop.client.photo ? 'height: 100px; width: 100px; border-radius: 145px;' : 'height: 37px; width: 46px'"
                        />
                      </div>

                      <div v-if="visitorDesktop.client.status && visitorDesktop.client.status.name && (visitorDesktop.client.status.id == 'ПотенциальныйЧленКлуба' || visitorDesktop.client.status.id == 'ПотенциальныйКлиентКлуба')" style="background-color:#ffc107;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>{{ visitorDesktop.client.status.name }}</span>
                      </div>
                      <div v-else-if="visitorDesktop.client.status && visitorDesktop.client.status.name && (visitorDesktop.client.status.id == 'БывшийЧленКлуба' || visitorDesktop.client.status.id == 'БывшийКлиентКлуба' || visitorDesktop.client.status.name == 'Отказ')" style="background-color:#f44336;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>{{ visitorDesktop.client.status.name }}</span> 
                      </div>
                      <div v-else style="background-color:#8bc34a;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>Член клуба</span>
                      </div>

                      <div class="card-title mt-5">
                        {{ visitorDesktop.client.name }}
                      </div>
                      <div class="card-subtitle mt-1">
                        <span v-if="+visitorDesktop.client.age < 100">{{ visitorDesktop.client.age }} </span>
                        
                        <span v-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]) && (+visitorDesktop.client.age === 21) || (+visitorDesktop.client.age === 31) || (+visitorDesktop.client.age === 41) || (+visitorDesktop.client.age === 51) || (+visitorDesktop.client.age === 61) || (+visitorDesktop.client.age === 71)"> год </span>
                        <span v-else-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]) && (+visitorDesktop.client.age === 22) || (+visitorDesktop.client.age === 32) || (+visitorDesktop.client.age === 42) || (+visitorDesktop.client.age === 52) || (+visitorDesktop.client.age === 62) || (+visitorDesktop.client.age === 72) || (+visitorDesktop.client.age === 23) || (+visitorDesktop.client.age === 33) || (+visitorDesktop.client.age === 43) || (+visitorDesktop.client.age === 53) || (+visitorDesktop.client.age === 63) || (+visitorDesktop.client.age === 73) || (+visitorDesktop.client.age === 24) || (+visitorDesktop.client.age === 34) || (+visitorDesktop.client.age === 44) || (+visitorDesktop.client.age === 54) || (+visitorDesktop.client.age === 64) || (+visitorDesktop.client.age === 74)"> года </span>
                        <span v-else-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1])"> лет </span>
                        <span v-else>-</span>
                        <span v-if="visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]">({{ visitorDesktop.client.birthday }})</span>
                        <span v-else></span>

                      </div>
                      <div class="card-title mt-3">
                        Посещений: {{ visitorDesktop.client.count_visit }}
                      </div>

                      <div v-if="visitorDesktop.client.visits_today && visitorDesktop.client.visits_today[0] && visitorDesktop.client.visits_today[0].active">
                        Клиент в клубе {{visitorDesktop.client.visits_today[0].duration}} с {{visitorDesktop.client.visits_today[0].date_start}}
                      </div>
                      <div v-else-if="visitorDesktop.client.last_visit && visitorDesktop.client.last_visit.date_end" class="card-subtitle mt-1">
                        Последнее посещение {{formatDate(visitorDesktop.client.last_visit) }}
                      </div>
                      <div v-else class="card-subtitle mt-1">
                        Последнее посещение: - 
                      </div>
                      
                    </div>
                  </v-sheet>
                  <v-sheet rounded="lg" class="card rounded-t-0">
                    <div class="client-info">
                      <div class="block">
                        <div class="personal-info">
                          <div class="item" v-if="visitorDesktop && visitorDesktop.client">
                            <div class="item__head item__grid">
                              <div class="left">Карта</div>
                              <div class="right justify-flex-end">
                                <button class="btn-icon">
                                  <Icon
                                      iconName="plus-circle"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      @click="dialogCard = true"
                                  />
                                </button>
                              </div>
                            </div>
                            <div class="item__value item__grid" v-for="card in visitorDesktop.client.cards" :key="card.card_id">
                              <div v-if="visitorDesktop.client.cards && card && (card !== null) && (card !== undefined)"  :class="card.card_status === 1 ? 'left active' : 'left block'" @click="cardInfo(card)">{{ card.card_number }}</div>
                            </div>
                          </div>

                          <div class="item">
                            <div class="item__head item__grid">
                              <div class="left">Лицевые и бонусные счета</div>
                              <div class="right">
                                <v-btn class="gray w-100" @click="modalBillPayment">
                                  Внести
                                </v-btn>
                              </div>
                            </div>
                            <div class="item__value item__grid" v-for="bill in visitorDesktop.client.main_bonus_bill"
                                 :key="bill.id">
                              <div class="left">{{ bill.name }}</div>
                              <div class="right text-right color-black">{{ bill.balance }} ₽</div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item__head item__grid">
                              <div class="left">Телефон</div>
                            </div>
                            <div class="item__value item__grid">
                              <div class="left">{{ (visitorDesktop.client.phone && visitorDesktop.client.phone.length > 0) ? visitorDesktop.client.phone[0] : '' }}</div>
                            </div>
                            <div class="item__value item__grid" v-if="visitorDesktop.client.phone && visitorDesktop.client.phone[1]">
                              <div class="left">{{ (visitorDesktop.client.phone[1] && visitorDesktop.client.phone[1].length > 0) ? visitorDesktop.client.phone[1] : '' }}</div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item__head item__grid">
                              <div class="left">Персональный менеджер</div>
                            </div>
                            <div class="item__value item__grid">
                              <div class="left">{{ visitorDesktop.client.manager.name }}</div>
                            </div>
                          </div>

                          <div class="item">
                            <div class="item__head item__grid">
                              <div class="left">Заметки</div>
                              <div class="right justify-flex-end">
                                <button class="btn-icon">
                                  <Icon
                                      iconName="plus-circle"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      @click="dialogNote = true"
                                  />
                                </button>
                              </div>
                            </div>
                            <div class="item__value item__grid" v-for="note in listNotes.notes"
                                 :key="note.id">
                              <div class="left" v-if="note.type === 1">{{ note.note }}</div>
                              <div class="right text-right color-black" v-if="note.type === 1" style="cursor:pointer;" @click="deleteNote(note.id)"> X </div>
                            </div>
                          </div>

                          
                        </div>

                      </div>
                    </div>
                    <v-btn :to="{ name: 'CardClient', params: {client_id: client_id} }" class="button__lighten-success"
                           style="min-width: 100% !important; margin-top: 30px !important;">
                      Профиль клиента
                    </v-btn>
                  </v-sheet>
                </template>
              </v-col>
              <v-col>
                <v-skeleton-loader
                    v-if="isLoadingDesktop"
                    type="table"
                >
                </v-skeleton-loader>
                <template v-else>
                  <v-tabs-items v-if="visitorDesktop.client.debts.length !== 0" v-model="tab">
                    <v-tab-item>
                      <v-sheet rounded="lg" class="card mb-5" style="color: #D53025 !important; height:500px; overflow-x:hidden;">
                        <span class="card-title">Задолженность {{ totalAmountDebt }} ₽</span>
                        <v-data-table
                            :headers="headersCredit"
                            :items="visitorDesktop.client.debts"
                            v-model="credits"
                            show-select
                            :hide-default-footer="true"
                            disable-pagination
                            item-key="buy.buy_name"
                            class="elevation-1 mt-3 custom__table"
                        >
                          <template v-slot:header.data-table-select="{ on, props }">
                            <v-tooltip
                                top
                                content-class="black tooltip-top"
                            >
                              Выбрать все
                              <template v-slot:activator="{ on: onTooltip }">
                                <v-simple-checkbox
                                    @click="allCredits()"
                                    v-ripple
                                    color="#629F33"
                                    v-bind="props"
                                    v-on="{ ...on, ...onTooltip }"
                                ></v-simple-checkbox>
                              </template>
                            </v-tooltip>
                          </template>
                          <template v-slot:item.data-table-select="{ isSelected, select }">
                            <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected"
                                               @input="select($event)"></v-simple-checkbox>
                          </template>
                          <template v-slot:item.buy.buy_name="{item}">
                            <v-list-group
                                color="#1A1A1A"
                                class="debts"
                                :ripple="false"
                                :value="false"
                            >
                              <template v-slot:activator>
                                <v-list-item-title class="debt-title">
                                  <router-link
                                      :to="{name: 'Sale', params: {client: visitorDesktop.client, buy_id: item.buy.buy_id, type: 'exist', for: 'client', deal: null}}"
                                      style="text-decoration: none; color: black"
                                  >
                                    {{ item.client.id !== visitorDesktop.client.client_id ? item.client.name + ' (' + item.client.type + ')' : item.buy.buy_name  + ' (' + item.org.org_name + ')' }}
                                  </router-link>
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                  v-for="it in item.buy_list" :key="it.name"
                              >
                                <v-list-item-title>
                                  <span class="debt-subtitle">{{ it.name }}</span>
                                </v-list-item-title>
                              </v-list-item>
                            </v-list-group>
                          </template>
                          <template v-slot:item.amount_debt="{item}">
                            {{ item.amount_debt }} ₽
                          </template>
                        </v-data-table>
                        <div class="text-right mt-5">
                          <v-btn
                              v-if="credits.length !== 0"
                              dark
                              class="payment-button"
                              @click="modalPayment"
                              style="background-color: #D53025!important;color: #fff!important;"
                          >
                            {{ 'Оплатить ' + chosenAmountDebt + ' ₽' }}
                          </v-btn>
                          <v-btn
                              v-else
                              dark
                              class="payment-button"
                              style="background-color: #F1F1F1!important;color: #000!important;"
                          >
                            Оплатить
                          </v-btn>
                        </div>
                      </v-sheet>
                    </v-tab-item>
                  </v-tabs-items>

                  <v-sheet
                      max-height="80px"
                      rounded="lg"
                      style="padding: 20px 0;"
                  >
                    <v-tabs
                        centered
                        id="horizontal_tabs"
                        class="custom__tab"
                        v-model="tab"
                    >
                      <v-tab
                          v-for="item in items"
                          :key="item.tab"
                          class="ml-4"
                      >
                        {{ item.tab }}
                      </v-tab>
                    </v-tabs>
                  </v-sheet>

                  <br>
                  <v-tabs-items v-model="tab" v-if="visitorDesktop" style="padding-bottom:200px;">
                    <v-tab-item>
                    <div class="scroll-table" style="padding-bottom:20px;">
                      <table id="table-1" cellpadding="1" >
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th class="no-wrap">Членство и пакет услуг</th>
                                    <th >Активен по</th>
                                    <th >Статус</th>
                                    <th >Остаток</th>
                                    <th >Действия</th>
                                  </tr>
                                </thead>
                                <tbody>
                                <template v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.productes && visitorDesktop.client.productes.length > 0">
                                  <template v-for="line of visitorDesktop.client.productes">
                                    <tr class="parrent" :key="line.product_id">
                                      <td >
                                        <template v-if="line.product_services && line.product_services.length > 0">
                                          <button
                                              :class="{ 'open-hide': true, open: openParentLine.includes(line.product_id) }"
                                              @click="openChildren(line.product_id)"
                                          >
                                          </button>
                                        </template>
                                      </td>
                                      <td >{{ line.product_name }}</td>
                                      <td >
                                        <span v-if="!line.product_lastdate.split('000')[1]">{{ line.product_lastdate }}</span>
                                      </td>
                                      <td >{{ line.status_description }}</td>
                                      <td >{{ line.product_balance }}</td>
                                      <td >
                                        <div class="sho_item" v-if="line.product_id !== '112233' && !line.ttt" @click="line.showChild = !line.showChild"
                                        style="
                                            cursor: pointer;
                                            width:50px; border-radius: 30px;
                                            transition: 0.5s;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            height: 30px;
                                        "
                                        ><span >...</span>
                                      </div>

                                          <div v-if="line.showChild " style="background-color: white; width:200px;                                         position: absolute;
                                              display: inline-block;
                                              overflow-y: auto;
                                              overflow-x: hidden;
                                              contain: content;
                                              box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
                                              border-radius: 8px;
                                              right:30px; font-size: 13px; transition:0.5s;">


                                            <v-list v-if="line.product_status !== 'Закрыт'" style="font-size: 13px; line-height:13px;">
                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="line.product_status !== 'Продан'"
                                                  :to="getRoute(line.product_status,line.product_id)"
                                              >
                                                <v-list-item-title>{{ getNameStatus(line.product_status) }}</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="line.product_status !== 'Продан' && line.activation_available === true"
                                                  :to="activateProduct(line.product_id)"
                                              >
                                                <v-list-item-title>Активировать</v-list-item-title>
                                              </v-list-item>


                                              <v-list-item
                                              style="min-height:38px;"
                                                  v-if="line.product_status === 'Продан' && line.activation_available === true"
                                                  @click="activateProduct(line.product_id)"
                                              >

                                                <v-list-item-title>{{ getNameStatus(line.product_status) }}</v-list-item-title>

                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ReturnService',
                                                  params: {client_id: visitorDesktop.client_id}
                                                }"
                                              >
                                                <v-list-item-title>Возврат</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: line.product_id, change_type: 'owner'}
                                                }"
                                              >
                                                <v-list-item-title>Оформить на другого клиента</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: line.product_id, change_type: 'nomenclature'}
                                                }"
                                              >
                                                <v-list-item-title>Сменить номенклатуру</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                style="min-height:38px;"
                                                    :to="{
                                                    name: 'ChangeOwner',
                                                    params: {client_id: client_id, product_id: line.product_id, product_lastdate: line.product_lastdate, change_type: 'changetime'}
                                                  }"
                                              >
                                                <v-list-item-title>Изменение срока действия</v-list-item-title>
                                              </v-list-item>

                                            </v-list>

                                            <v-list v-else>

                                            </v-list>

                                          </div>

                                      </td>
                                    </tr>


                                    <template v-if="(!line.ttt || line.ttt === false) && line.product_services && line.product_services.length > 0">

                                      <template v-for="children of line.product_services">
                                        <tr
                                            v-if="openParentLine.includes(line.product_id)"
                                            :key="children.service_id"
                                            :class="{ children: true, open: openParentLine.includes(line.service_id) }"
                                        >
                                          <td ></td>
                                          <td >{{ children.service_name }}</td>
                                          <td >{{ children.service_lastdate }}</td>
                                          <td ></td>
                                          <td >{{ children.service_balance }}</td>
                                          <td >

                                            <div class="sho_item" @click="children.showChild = !children.showChild"
                                        style="
                                            cursor: pointer;
                                            width:50px; border-radius: 30px;
                                            transition: 0.5s;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            height: 30px;
                                        "
                                        ><span>...</span></div>
                                          <div v-if="children.showChild" style="background-color: white; width:200px;                                         position: absolute;
                                              display: inline-block;
                                              overflow-y: auto;
                                              overflow-x: hidden;
                                              contain: content;
                                              box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
                                              border-radius: 8px;
                                              right:30px; font-size: 13px; transition:0.5s;">
                                            <v-list>
                                                <v-list-item
                                                    :to="{
                                                    name: 'Schedule',
                                                    params: {
                                                      from: 'reception',
                                                      service: children,
                                                      client_id: client_id,
                                                      client_name: visitorDesktop.client.name,
                                                      specialist_main:children.specialist
                                                    }
                                                  }"
                                                >
                                                  <v-list-item-title>Использовать</v-list-item-title>
                                                </v-list-item>
                                              </v-list>
                                            </div>
                                          </td>
                                        </tr>
                                      </template>

                                    </template>

                                    <template v-if="line.ttt && line.product_services && line.product_services.length > 0">

                                      <template v-for="children of line.product_services">
                                        <tr
                                            v-if="openParentLine.includes(line.product_id)"
                                            :key="children.product_id"
                                            :class="{ children: true, open: openParentLine.includes(line.product_id) }"
                                        >
                                          <td>
                                            <template v-if="children.product_services && children.product_services.length > 0">
                                              <button
                                                  :class="{ 'open-hide': true, open: openParentLine.includes(children.product_id) }"
                                                  @click="openChildren(children.product_id)"
                                              >
                                              </button>
                                            </template>
                                          </td>

                                          <td >{{ children.product_name }}</td>
                                          <td >
                                            <span v-if="!children.product_lastdate.split('000')[1]">{{ children.product_lastdate }}</span>
                                          </td>
                                            <td >{{ children.status_description }}</td>
                                                <td >{{ children.product_balance }}</td>
                                                <td >
                                                  <div class="sho_item" v-if="children.product_id !== '112233'" @click="children.showChild = !children.showChild"
                                                  style="
                                                      cursor: pointer;
                                                      width:50px; border-radius: 30px;
                                                      transition: 0.5s;
                                                      display: flex;
                                                      align-items: center;
                                                      justify-content: center;
                                                      height: 30px;
                                                  "
                                                  ><span >...</span>
                                              </div>

                                          <div v-if="children.showChild " style="background-color: white; width:200px;                                         position: absolute;
                                              display: inline-block;
                                              overflow-y: auto;
                                              overflow-x: hidden;
                                              contain: content;
                                              box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
                                              border-radius: 8px;
                                              right:30px; font-size: 13px; transition:0.5s;">


                                            <v-list v-if="children.product_status !== 'Закрыт'" style="font-size: 13px; line-height:13px;">
                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="children.product_status !== 'Продан'"
                                                  :to="getRoute(children.product_status,children.product_id)"
                                              >
                                                <v-list-item-title>{{ getNameStatus(children.product_status) }}</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="children.product_status !== 'Продан' && children.activation_available === true"
                                                  :to="activateProduct(children.product_id)"
                                              >
                                                <v-list-item-title>Активировать</v-list-item-title>
                                              </v-list-item>


                                              <v-list-item
                                              style="min-height:38px;"
                                                  v-if="children.product_status === 'Продан' && children.activation_available === true"
                                                  @click="activateProduct(children.product_id)"
                                              >

                                                <v-list-item-title>{{ getNameStatus(children.product_status) }}</v-list-item-title>

                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ReturnService',
                                                  params: {client_id: visitorDesktop.client_id}
                                                }"
                                              >
                                                <v-list-item-title>Возврат</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: children.product_id, change_type: 'owner'}
                                                }"
                                              >
                                                <v-list-item-title>Оформить на другого клиента</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: children.product_id, change_type: 'nomenclature'}
                                                }"
                                              >
                                                <v-list-item-title>Сменить номенклатуру</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                style="min-height:38px;"
                                                    :to="{
                                                    name: 'ChangeOwner',
                                                    params: {client_id: client_id, product_id: children.product_id, product_lastdate: children.product_lastdate, change_type: 'changetime'}
                                                  }"
                                              >
                                                <v-list-item-title>Изменение срока действия</v-list-item-title>
                                              </v-list-item>

                                            </v-list>

                                            <v-list v-else>

                                            </v-list>

                                          </div>

                                      </td>
                                        </tr>

                                      <template v-if="children.product_services && children.product_services.length > 0">

                                        <template v-for="children2 of children.product_services">
                                          <tr
                                              v-if="openParentLine.includes(children.product_id)"
                                              :key="children2.service_id"
                                              :class="{ children: true, open: openParentLine.includes(children.service_id) }"
                                          >
                                            <td ></td>
                                            <td >{{ children2.service_name }}</td>
                                            <td >{{ children2.service_lastdate }}</td>
                                            <td ></td>
                                            <td >{{ children2.service_balance }}</td>
                                            <td >

                                              <div class="sho_item" @click="children2.showChild = !children2.showChild"
                                          style="
                                              cursor: pointer;
                                              width:50px; border-radius: 30px;
                                              transition: 0.5s;
                                              display: flex;
                                              align-items: center;
                                              justify-content: center;
                                              height: 30px;
                                          "
                                          ><span>...</span></div>
                                            <div v-if="children2.showChild" style="background-color: white; width:200px;                                         position: absolute;
                                                display: inline-block;
                                                overflow-y: auto;
                                                overflow-x: hidden;
                                                contain: content;
                                                box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
                                                border-radius: 8px;
                                                right:30px; font-size: 13px; transition:0.5s;">
                                              <v-list>
                                                  <v-list-item
                                                      :to="{
                                                      name: 'Schedule',
                                                      params: {
                                                        from: 'reception',
                                                        service: children2,
                                                        client_id: client_id,
                                                        client_name: visitorDesktop.client.name,
                                                        specialist_main:children.specialist
                                                      }
                                                    }"
                                                  >
                                                    <v-list-item-title>Использовать</v-list-item-title>
                                                  </v-list-item>
                                                </v-list>
                                              </div>
                                            </td>
                                          </tr>
                                        </template>

                                    </template>
                                      </template>

           


                                    </template>

                                  </template>
                                </template>
                                </tbody>
                      </table>
                    </div>
         
                      <!-- <v-data-table
                          :headers="headersSubscribe"
                          :items="visitorDesktop.client.productes"
                          no-data-text="Нет активных пакетов"
                          :hide-default-footer="true"
                          item-key="name"
                          class="elevation-1 rounded-lg"
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-menu
                              bottom
                              left
                              offset-y
                              rounded="lg"
                              content-class="custom__menu"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  primary
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  class="dots-button__actions"
                              >
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>


                            <v-list v-if="item.product_status !== 'Закрыт'">
                              <v-list-item
                                  v-if="item.product_status !== 'Продан'"
                                  :to="getRoute(item.product_status,item.product_id)"
                              >
                                <v-list-item-title>{{ getNameStatus(item.product_status) }}</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  v-if="item.product_status === 'Продан'"
                                  @click="activateProduct(item.product_id)"
                              >
                                <v-list-item-title>{{ getNameStatus(item.product_status) }}</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  :to="{
                                  name: 'ReturnService',
                                  params: {client_id: visitorDesktop.client_id}
                                }"
                              >
                                <v-list-item-title>Возврат</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  :to="{
                                  name: 'ChangeOwner',
                                  params: {client_id: client_id, product_id: item.product_id, change_type: 'owner'}
                                }"
                              >
                                <v-list-item-title>Оформить на другого клиента</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  :to="{
                                  name: 'ChangeOwner',
                                  params: {client_id: client_id, product_id: item.product_id, change_type: 'nomenclature'}
                                }"
                              >
                                <v-list-item-title>Сменить номенклатуру</v-list-item-title>
                              </v-list-item>
                            </v-list>
                            <v-list v-else>

                            </v-list>
                          </v-menu>
                        </template>
                      </v-data-table> -->
                      <!-- <v-data-table
                          :headers="headersService"
                          :items="visitorDesktop.client.services"
                          no-data-text="Нет активных услуг"
                          :hide-default-footer="true"
                          item-key="name"
                          class="elevation-1 rounded-lg mt-5 mb-2"
                      >
                      <template v-slot:item.service_balance="{item}">
                            {{ item.service_balance ? item.service_balance : 'неогр.' }}
                      </template>
                        <template v-slot:item.actions="{ item }">
                          <v-menu
                              bottom
                              left
                              offset-y
                              rounded="lg"
                              content-class="custom__menu"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  primary
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  class="dots-button__actions"
                              >
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>


                            <v-list>
                              <v-list-item
                                  :to="{
                                  name: 'Schedule',
                                  params: {
                                    from: 'reception',
                                    service: item,
                                    client_id: client_id,
                                    client_name: visitorDesktop.client.name,
                                  }
                                }"
                              >
                                <v-list-item-title>Использовать</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                      </v-data-table> -->

                      <v-sheet rounded="lg" class="card mt-5" style="padding-bottom: 0 !important;" v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.visits_today && visitorDesktop.client.visits_today.length > 0">
                      <span class="card-title">
                        <v-icon
                            small
                        >
                            mdi-clock-outline
                        </v-icon>
                        Сегодня
                      </span>
                        <v-data-table
                            :headers="headersVisits"
                            :items="visitorDesktop.client.visits_today"
                            no-data-text="Нет посещений на сегодня"
                            :hide-default-footer="true"
                            item-key="name"
                            class="elevation-1 rounded-lg mt-2 custom__table"
                        >
                          <template v-slot:item.date_end="{item}">
                            {{ item.date_end ? (item.date_end.split('T')[1] ? (item.date_end.split('T')[1].split(':')[0]+':'+item.date_end.split('T')[1].split(':')[1]) : item.date_end) : '' }}
                          </template>
                          <template v-slot:item.duaration="{item}">
                            {{ item.duaration }}
                          </template>
                          <template v-slot:item.aa="{item}">
                            {{ (item.service && item.service.name) ? item.service.name : ((item.base && item.base.name) ? item.base.name : "")}}
                          </template>
                        </v-data-table>
                      </v-sheet>

                    <v-sheet rounded="lg" class="card mt-5" style="padding-bottom: 0 !important;" v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.rents && visitorDesktop.client.rents.length > 0">
                      <span class="card-title">
              
                        Аренда
                      </span>
                        <v-data-table
                            :headers="headersRents"
                            :items="visitorDesktop.client.rents"
                            no-data-text="Нет Аренд"
                            :hide-default-footer="true"
                            item-key="name"
                            class="elevation-1 rounded-lg mt-2 custom__table"
                        >
                          <template v-slot:item.date_end="{item}">
                            {{ item.date_end ? item.date_end : '' }}
                          </template>
                          <template v-slot:item.duaration="{item}">
                            {{ item.duaration }}
                          </template>
                        </v-data-table>
                      </v-sheet>

                    </v-tab-item>


                    <v-tab-item
                    >
                      <v-data-table
                          v-if="listRelatives"
                          :headers="headersRelations"
                          :items="listRelatives.relatives"
                          :hide-default-footer="true"
                          item-key="id"
                          class="elevation-1"
                          disable-pagination
                      >
                        <template v-slot:body="{ items, headers }">
                          <tbody name="list" is="transition-group" v-if="items.length > 0">
                          <tr v-for="item in items" :key="item.id">
                            <td @click="editRelation(item)">
                              {{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}
                            </td>
                            <td>{{ item.relatives_type.name }}</td>
                            <td>{{ item.phone }}</td>
                          </tr>
                          </tbody>
                          <tbody v-else>
                          <tr class="v-data-table__empty-wrapper">
                            <td :colspan="headers.length">Родственников не найдено</td>
                          </tr>
                          </tbody>
                        </template>
                      </v-data-table>

                      <button
                          class="button button__success d-flex mt-5"
                          ref="activator"
                          type="button"
                          @click="addRelation"
                          style="align-items: center !important;"
                      >
                        <v-icon
                            dark
                            small
                            class="mr-1"
                        >
                          mdi-plus-circle-outline
                        </v-icon>
                        <span style="font-size: 13px !important; line-height: 16px !important;">
                        Добавить
                      </span>
                      </button>

                    </v-tab-item>
                    <v-tab-item
                    >
                      <v-data-table
                          v-if="listNotes"
                          :headers="headersNotes"
                          :items="listNotes.notes"
                          no-data-text="Заметок не найдено"
                          :hide-default-footer="true"
                          item-key="id"
                          class="elevation-1"
                      >
                        <template v-slot:item="{ item, index }">
                          <tr v-if="item.type === 1" :style="editNoteStatus && editNoteId === item.id ? 'background: #E0ECD6 !important' : 'background: #fff !important'">
                            <td class="text-start">{{ index + 1 }}</td>
                            <td class="text-start">{{ item.note }}</td>
                            <td class="text-start">
                              <div class="d-flex" style="align-items: center">
                                <div>
                                  <v-img :src="visitorDesktop.client.photo" :alt="visitorDesktop.client.name"
                                         style="height: 24px; width: 24px; border-radius: 12px;"></v-img>
                                </div>
                                <div class="ml-2">
                                  {{ visitorDesktop.client.name }}
                                </div>
                              </div>
                            </td>
                            <td class="text-start">
                              <v-menu
                                  bottom
                                  left
                                  offset-y
                                  rounded="lg"
                                  content-class="custom__menu"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      primary
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      class="dots-button__actions"
                                  >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>

                                <v-list>
                                  <v-list-item
                                      @click="editNote(item.id, item.note)"
                                  >
                                    <v-list-item-title>Редактировать</v-list-item-title>
                                  </v-list-item>

                                  <v-list-item
                                      @click="deleteNote(item.id)"
                                  >
                                    <v-list-item-title>Удалить</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>

                      <div class="note-title mt-4 mb-2">
                        Новая заметка
                      </div>
                      <v-form ref="noteForm" @submit.prevent="noteSubmit">
                        <v-textarea
                            v-model="note"
                            :rules="noteRules"
                            rounded
                            outlined
                            dense
                            required
                            auto-grow
                            background-color="#fff"
                            rows="5"
                            style="width: 100%; height: 150px"
                        ></v-textarea>

                        <v-row class="justify-end justify-end-bottom">
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                              style="font-size: 13px; font-weight: 700; padding: 8px 20px !important; align-content: center"
                          >
                          <span style="font-size: 13px !important; line-height: 16px !important;">
                            {{ editNoteStatus ? 'Сохранить' : 'Добавить' }}
                          </span>
                          </button>
                        </v-row>
                      </v-form>
                    </v-tab-item>
                  </v-tabs-items>
                </template>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Родственник</h4>
                    </div>
                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="relationForm" @submit.prevent="addRelationSubmit">
                        <v-row>
                          <v-col
                              cols="12"
                          >
                            <v-switch
                                label="Существующий клиент"
                                style="height: 30px;"
                                color="#629F33"
                                inset
                                @change="changeState"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Телефон <span style="color: #D53025">*</span></label>
                            <v-text-field
                                v-model="phone"
                                :rules="phoneRules"
                                v-mask="'+7 (###) ###-##-###'"
                                label="Телефон"
                                required
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Фамилия</label>
                            <v-text-field
                                v-model="middle_name"
                                label="Фамилия"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Имя <span style="color: #D53025">*</span></label>
                            <v-text-field
                                v-model="first_name"
                                :rules="firstNameRules"
                                label="Имя"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Отчество</label>
                            <v-text-field
                                v-model="last_name"
                                label="Отчество"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Дата рождения</label>
                            <template>
                              <VueDatePicker
                                  no-title
                                  no-header
                                  color="#629f34"
                                  v-model="date_birthday"
                                  :max-date="maxDate"
                                  :visible-years-number="124"
                                  placeholder="Выбрать"
                              >
                                <template #activator="{ date }">
                                  <button
                                      class="button custom__datepicker"
                                      ref="activator"
                                      type="button"
                                      style="white-space: nowrap; width: 80% !important;"
                                  >
                                    {{ date }}
                                    <v-icon
                                        medium
                                        right
                                        class="ml-2"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </button>
                                </template>
                              </VueDatePicker>
                            </template>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Пол</label>
                            <v-select
                                v-model="gender"
                                :items="genderTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Пол"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              v-if="!unsetClient"
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Родственник</label>
                            <div class="d-flex">
                      
                              <v-autocomplete
                                  colspan="1"
                                  :items="listClient ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск клиентов"
                                  no-data-text="Результатов не найдено"
                                  color="#629F33"
                                  item-color="success"
                                  :search-input.sync="search"
                                  v-model="select"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                                  :no-filter=true
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  hide-selected
                                  outlined
                                  dense
                                  background-color="white"
                                  return-object
                                  style="height: 30px;margin-top: 10px"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>
                              </v-autocomplete>


       
                              <v-btn v-show="select !== null" @click="fetchFeed(select.client_id)"
                                     class="button__lighten-success ml-3"
                                     style="height: 40px !important;margin-top: 10px !important;">
                                Рабочий стол
                              </v-btn>
                            </div>

                            <div v-if="select && select !== null">
                            <br>
                                <span style="font-weight:bold; font-size:16px;">{{ select.name }}</span>
                              </div>
                              
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Степень родства <span style="color: #D53025">*</span></label>
                            <v-select
                                v-if="listRelativesTypes"
                                v-model="relative_type"
                                :rules="relativeTypeRules"
                                :items="listRelativesTypes.relatives"
                                item-value="id"
                                item-text="name"
                                label="Степень родства"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <v-switch
                                v-model="is_representative"
                                label="Законный представитель"
                                color="#629F33"
                                inset
                                style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Лицевой счет</label>
                            <v-select
                                v-model="main_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Лицевой счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Бонусный счет</label>
                            <v-select
                                v-model="bonus_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Бонусный счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px;"
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row
                            align="center"
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="8"
                          >
                            <v-text-field
                                v-model="card_number_par"
                                label="Номер карты"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <button
                                class="button button__success purpure-button"
                                ref="activator"
                                type="button"
                                style="padding: 8px 20px !important; font-weight: 700;"
                                @click="searchBraceletPar"
                            >
                              Сгенерировать
                            </button>
                          </v-col>
                        </v-row>


                        <v-row>
                          
                        </v-row>
                        <v-row class="mt-5">
                          <v-card-actions style="padding: 20px 10px !important;">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                                :disabled="relative_adding"
                            >
                              Сохранить
                            </button>
                          </v-card-actions>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogRelationEdit"
                  persistent
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Родственник</h4>
                    </div>
                    <v-btn icon @click="dialogRelationEdit = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="form" @submit.prevent="editRelationSubmit">
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Родственник <span style="color: #D53025">*</span></label>
                            <div class="d-flex">
                              <v-text-field
                                  v-model="editRelationItems.name"
                                  label="Родственник"
                                  class="rounded-lg"
                                  outlined
                                  dense
                                  readonly
                                  style="height: 48px;margin-top: 10px"
                              ></v-text-field>
                              <v-btn v-show="editRelationItems.id !== null" @click="fetchFeed(editRelationItems.id)"
                                     class="button__lighten-success ml-3"
                                     style="height: 40px !important;margin-top: 10px !important;">
                                Рабочий стол
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Степень родства <span style="color: #D53025">*</span></label>
                            <v-select
                                v-if="listRelativesTypes"
                                v-model="editRelationItems.relative_type"
                                :rules="relativeTypeRules"
                                :items="listRelativesTypes.relatives"
                                item-value="id"
                                item-text="name"
                                label="Степень родства"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <v-switch
                                v-model="editRelationItems.is_representative"
                                label="Законный представитель"
                                color="#629F33"
                                inset
                                style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                            ></v-switch>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Лицевой счет</label>
                            <v-select
                                v-model="editRelationItems.main_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Лицевой счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Бонусный счет</label>
                            <v-select
                                v-model="editRelationItems.bonus_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Бонусный счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px;"
                            ></v-select>
                          </v-col>
                          <v-card-actions style="padding: 20px 10px !important;">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                            <button
                                class="button button__danger ml-3"
                                ref="activator"
                                type="button"
                                style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                                @click="deleteRelationSubmit"
                            >
                              Удалить
                            </button>
                          </v-card-actions>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCard"
                  persistent
                  max-width="600px"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCard = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 70px;">
                    <v-container>
                      <v-form ref="form" @submit.prevent="addCard">
                        <div class="text-center">
                          <h3 class="text-center">Добавить новую карту</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="8"
                          >
                            <v-text-field
                                v-model="card_number"
                                :rules="cardNumberRules"
                                label="Номер карты"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <button
                                class="button button__success purpure-button"
                                ref="activator"
                                type="button"
                                style="padding: 8px 20px !important; font-weight: 700;"
                                @click="searchBracelet"
                            >
                              Сгенерировать
                            </button>
                          </v-col>

                          <button
                              class="button button__secondary"
                              ref="activator"
                              type="submit"
                              style="margin:auto; font-weight: 700;"
                          >
                            Сохранить
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center" v-if="card">
              <v-dialog
                  v-model="dialogCardEdit"
                  persistent
                  max-width="600px"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCardEdit = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 70px;">
                    <v-container>
                      <div class="text-center">
                        <h3 class="text-center">Данные по карте</h3>
                      </div>
                      <v-row
                          align="center"
                          class="mt-5 d-flex flex-column justify-center"
                      >
                        <v-col cols="6" style="padding: 0!important;">
                          <v-text-field
                              v-if="chosenCard"
                              v-model="chosenCard.card_number"
                              label="Номер карты"
                              class="rounded-lg"
                              outlined
                              dense
                              readonly
                              style="height: 48px;margin-top: 10px"
                              value="SGH124197915"
                          ></v-text-field>
                        </v-col>
                        <span class="card-edit__subtitle">Приложите карту к считывателю</span>
                        <button
                            v-if="chosenCard"
                            :class="chosenCard.card_status === 2 ? 'button button__success' : 'button button__danger'"
                            ref="activator"
                            type="button"
                            @click="chosenCard.card_status === 2 ? unlock(chosenCard.card_id) : block(chosenCard.card_id)"
                            style="margin:auto; font-weight: 700;"
                        >
                          {{ chosenCard.card_status === 2 ? 'Разблокировать' : 'Заблокировать' }}
                        </button>
                        <button
                            class="button__danger"
                            ref="activator"
                            type="button"
                            @click=" deleteCard(chosenCard.card_id)"
                            style="margin:auto; font-weight: 700;"
                        >
                          Удалить
                        </button>
                      </v-row>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogPayment"
                  persistent
                  max-width="540px"
              >

                <v-form
                    ref="formPayment"
                    v-model="validDialogPayment"
                >
                  <v-card rounded="lg">
                    <v-card-title class="justify-space-between">
                      <div></div>
                      <div>
                        <h4>Взнос на лицевой счет</h4>
                      </div>
                      <v-btn icon @click="dialogPayment = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row class="d-flex justify-space-between mt-5">
                          <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                            <span class="payment-text">Чек на</span>
                          </div>
                          <div style="width: 65%">
                            <v-btn-toggle
                                mandatory
                                background-color="white"
                                class="mx-4 rounded-lg"
                                v-model="dialogTypeSender"
                            >
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-phone-incoming-outline
                                </v-icon>
                                Телефон
                              </v-btn>
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-email-outline
                                </v-icon>
                                Эл. почту
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </v-row>

                        <v-btn-toggle
                            v-model="dialogDebitTypeOfPayment"
                            mandatory
                            background-color="#FFFFFF"
                            class="rounded-lg"
                            style="margin-top: 40px; width: 100%"
                        >
                          <v-btn width="50%">
                            Наличные
                          </v-btn>
                          <v-btn width="50%">
                            Карта
                          </v-btn>
                        </v-btn-toggle>
                        <v-row class="mt-5">
                          <v-col cols="12">
                            <label>Касса</label>
                            <v-select
                                v-model="cashbox_debit"
                                :rules="cashboxRules"
                                :items="listCashbox"
                                item-text="legal_entity"
                                item-value="serial"
                                class="rounded-lg"
                                label="Выбрать"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                append-icon="mdi-chevron-down"
                                outlined
                                hide-details
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <label>Л/С</label>
                            <div style="display:flex; align-items: center; margin-top:20px;">
                              <v-btn-toggle
                                  v-model="billTypeChosed"
                                  mandatory
                                  background-color="#FFFFFF"
                                  class="rounded-lg"
                                  style="margin-top: -30px; width: 50%"
                              >
                                <v-btn style="height:40px !important;">
                                  Открытый
                                </v-btn>
                                <v-btn style="height:40px !important;">
                                  Новый
                                </v-btn>
                              </v-btn-toggle>
                              <!-- item-text="deposit_name" -->
                              <v-select
                                v-if="billTypeChosed === 0"
                                v-model="bill_debit"
                                :rules="mainBillRules"
                                :items="listBill ? listBill.list : []"
                                
                                :item-text="item=>`${item.deposit_name} (Организация: ${(item.organization && item.organization.name) ? item.organization.name : 'не определена'} ) `"
                                item-value="deposit_id"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать открытый"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                style="width:50%;"
                            ></v-select>
                              <!-- item-text="name" -->
                            <v-select
                                v-else
                                v-model="bill_debit"
                                :rules="mainBillRules"
                                :items="listBillNew ? listBillNew.list : []"
                                :item-text="item=>`${item.name} (Организация: ${(item.organization && item.organization.name) ? item.organization.name : 'не определена'} ) `"
                                item-value="id"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать новый"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>

                            </div>
                  
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <label>Сумма взноса</label>
                            <v-text-field
                                v-model="make_summ"
                                :rules="makeSummRules"
                                placeholder="0"
                                outlined
                                dense
                                class="rounded-lg"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <label>Внесено</label>
                            <v-text-field
                                v-model="summ_contributed"
                                :rules="makeSummRules"
                                placeholder="0"
                                outlined
                                dense
                                class="rounded-lg"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <label>Сдача</label>
                            <v-text-field
                                v-model="odd_money"
                                outlined
                                disabled
                                dense
                                class="rounded-lg"
                                background-color="#F1F1F1"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px; color: rgba(98, 159, 51, 1)">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn
                                class="button button__success"
                                style="width: 100% !important; height: 48px !important;"
                                type="button"
                                @click="submitFormMakePayment"
                                :disabled="isLoadingCashbox || isLoadingAccount"
                            >
                              Внести
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogDeleteNote"
                  persistent
                  max-width="400px"
              >
                <v-form @submit.prevent="deleteNoteSubmit">
                  <v-card>
                    <v-card-title class="text-center">
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialogDeleteNote = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 30px;">
                      <v-container>
                        <div>
                          <h3 class="card-title">Вы уверены, что хотите удалить заметку?</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5 justify-center"
                        >
                          <button
                              class="button button__danger"
                              ref="activator"
                              type="submit"
                          >
                            Да
                          </button>
                          <button
                              class="button button__unlock ml-5"
                              ref="activator"
                              type="button"
                              @click="dialogDeleteNote = false"
                          >
                            Нет
                          </button>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogDebitPayment"
                  persistent
                  max-width="540px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Оплата</h4>
                    </div>
                    <v-btn icon @click="dialogDebitPayment = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="creditsForm" @submit.prevent="makePayment">
                        <v-row class="d-flex justify-space-between mt-5">
                          <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                            <span class="payment-text">Чек на</span>
                          </div>
                          <div style="width: 65%">
                            <v-btn-toggle
                                v-model="check_to"
                                mandatory
                                background-color="white"
                                class="mx-4 rounded-lg"
                            >
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-phone-incoming-outline
                                </v-icon>
                                Телефон
                              </v-btn>
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-email-outline
                                </v-icon>
                                Эл. почту
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </v-row>
                        <v-btn-toggle
                            v-model="dialogTypeOfPayment"
                            mandatory
                            background-color="#FFFFFF"
                            class="rounded-lg"
                            style="margin-top: 40px; width: 100%"
                        >
                          <v-btn width="25%">
                            Наличные
                          </v-btn>
                          <v-btn width="25%">
                            Л/C
                          </v-btn>
                          <v-btn width="25%">
                            Карта
                          </v-btn>
                          <v-btn width="25%">
                            Бонусы
                          </v-btn>
                        </v-btn-toggle>

                        <v-row class="mt-5">
                          <v-col cols="12">
                            <label>Касса</label>
                            <v-select
                                v-model="cashbox"
                                :rules="cashboxRules"
                                :items="listCashbox"
                                no-data-text="Нет доступных касс"
                                item-text="legal_entity"
                                item-value="serial"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="dialogTypeOfPayment === 1" class="mt-1">
                          <v-col cols="12">
                            <label>Л/С</label>
                            <v-select
                                v-model="main_bill_debit"
                                :rules="mainBillDebtRules"
                                :items="listBill ? listBill.list : []"
                                item-text="deposit_name"
                                return-object
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-tabs-items v-model="dialogTypeOfPayment" class="mt-5">
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    type="number"
                                    outlined
                                    disabled
                                    dense
                                    class="rounded-lg"
                                    background-color="#F1F1F1"
                                    color="success"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                  v-if="main_bill_debit"
                              >
                                <label>Л/C</label>
                                <v-text-field
                                    v-model="main_bill_debit.deposit_balance"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                    color="#629F33"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </v-tabs-items>
                        <v-row>
                          <v-col>
                            <v-btn
                                v-if="!isLoading2"
                                class="button button__success"
                                type="submit"
                                style="width: 100% !important; height: 48px !important;"
                                :disabled="isLoadingCashbox || doingPayment"
                            >
                              Оплатить
                            </v-btn>
                            <v-btn
                                class="button button__danger"
                                @click="cancelReceipt"
                                style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                                :disabled="!doingPayment"
                            >
                              Отмена операции
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

        <v-row justify="center">
          <v-dialog
              v-model="dialogOfPaymentPart"
              persistent
              max-width="840px"
          >
              
            <v-card rounded="lg" >
     
              <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Оплата</h4>
                  </div>
                  <v-btn icon @click="dialogOfPaymentPart = false" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-data-table
                            :headers="headersCredit"
                            :items="visitorDesktop.client.debts"
                            v-model="credits"
                            show-select
                            :hide-default-footer="true"
                            disable-pagination
                            item-key="buy.buy_name"
                            class="elevation-1 mt-3 custom__table"
                        >
                          <template v-slot:header.data-table-select="{ on, props }">
                            <v-tooltip
                                top
                                content-class="black tooltip-top"
                            >
                              Выбрать все
                              <template v-slot:activator="{ on: onTooltip }">
                                <v-simple-checkbox
                                    @click="allCredits()"
                                    v-ripple
                                    color="#629F33"
                                    v-bind="props"
                                    v-on="{ ...on, ...onTooltip }"
                                ></v-simple-checkbox>
                              </template>
                            </v-tooltip>
                          </template>
                          <template v-slot:item.data-table-select="{ isSelected, select }">
                            <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected"
                                               @input="select($event)"></v-simple-checkbox>
                          </template>
                          <template v-slot:item.buy.buy_name="{item}">
                            <v-list-group
                                color="#1A1A1A"
                                class="debts"
                                :ripple="false"
                                :value="false"
                            >
                              <template v-slot:activator>
                                <v-list-item-title class="debt-title">
                                  <router-link
                                      :to="{name: 'Sale', params: {client: visitorDesktop.client, buy_id: item.buy.buy_id, type: 'exist', for: 'client', deal: null}}"
                                      style="text-decoration: none; color: black"
                                  >
                                    {{ item.client.id !== visitorDesktop.client.client_id ? item.client.name + ' (' + item.client.type + ')' : item.buy.buy_name  + ' (' + item.org.org_name + ')' }}
                                  </router-link>
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                  v-for="it in item.buy_list" :key="it.name"
                              >
                                <v-list-item-title>
                                  <span class="debt-subtitle">{{ it.name }}</span>
                                </v-list-item-title>
                              </v-list-item>
                            </v-list-group>
                          </template>
                          <template v-slot:item.amount_debt="{item}">
                            {{ item.amount_debt }} ₽
                          </template>
                        </v-data-table>
                  </v-container>
                </v-card-text>

              <v-card-text>
                  <v-container>
                    <v-form ref="form" @submit.prevent="makePaymentPart">
                      <div style="display:flex;">
        
                        <v-row class="d-flex mt-5" style="flex-direction: column;">
                          <div>Касса:
                            <span style="color:red;" v-if="!listCashbox || listCashbox.length == 0">Касса не подключена</span>
                            <span v-else>{{sale.org.legal_entity}} ({{sale.org.inn}}) </span>
                          </div>
                          <div v-if="listCashbox && sale.org">Организация:
                            <span>{{sale.org.legal_entity}} ({{sale.org.inn}})</span>
                          </div>
                          <div v-else>Организация:
                            <span v-if="saleOrg">{{saleOrg.name}} ({{ saleOrg.inn }})</span>
                            <span v-else style="color:red;">Организация не выбрана</span>
                          </div>
                        </v-row>
                      </div>
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 10%; display: flex; align-items: center; justify-content: start">
                          <span class="payment-text">Чек на</span>
                        </div>
                        <div style="width: 90%">
                          <v-btn-toggle
                              v-model="check_to"
                              mandatory
                              background-color="white"
                              class="mx-4 rounded-lg"
                          >
                            <v-btn>
                              <v-icon
                                  small
                                  dark
                                  class="mr-2"
                              >
                                mdi-phone-incoming-outline
                              </v-icon>
                              Телефон
                            </v-btn>
                            <v-btn>
                              <v-icon
                                  small
                                  dark
                                  class="mr-2"
                              >
                                mdi-email-outline
                              </v-icon>
                              Эл. почту
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                      </v-row>
                      <v-btn-toggle
                          v-model="dialogTypeOfPaymentPart"
                          mandatory
                          background-color="#FFFFFF"
                          class="rounded-lg"
                          multiple
                          style="margin-top: 40px; width: 100%; flex-direction: column;"
                      >
                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 50px;
                        ">
                          <div style="cursor:pointer;" @click="toCashPay()">Наличные: </div>

                          <div v-if="ifCashPay" style="display:flex; align-items: center; margin-left:10px;">
                            <input v-if="!cash_in_part_setted" type="text" v-model="cash_in_part_pre" style="background-color: white; padding:5px; width:100px;" />
                            <input v-else type="text" v-model="cash_in_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                            <div style="
                            width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                            display: flex;
                            align-items: center;
                            justify-content: center;" >
                              <div v-if="cash_in_part_setted" @click="setCashPart(false)">X</div>
                              <div v-else @click="setCashPart(true)">OK</div>
                            </div>
                          </div>

                        </div>

                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 50px;
                        ">
                          <div style="cursor:pointer;" @click="toCardPay()">Платёжная карта: </div>

                          <div v-if="ifCardPay" style="display:flex; align-items: center; margin-left:10px;">
                            <input v-if="!card_part_setted" type="text" v-model="summ_card_part_pre" style="background-color: white; padding:5px; width:100px;" />
                            <input v-else type="text" v-model="summ_card_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                            <div style="
                            width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                            display: flex;
                            align-items: center;
                            justify-content: center;" >
                              <div v-if="card_part_setted" @click="setCardPart(false)">X</div>
                              <div v-else @click="setCardPart(true)">OK</div>
                            </div>
                          </div>

                        </div>

                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 60px;
                        ">
                          <div>Лицевые счета: </div>

                            <div style="padding-top: 20px;">
                              <v-select
                                  v-model="main_bill_part_def"
                                  :rules="mainBillRules"
                                  :items="listBill ? listBill.list : []"
                                  :item-text="item=>`${item.deposit_name} ( ${item.deposit_balance} р.) ( ${item.deposit_id.substr(0, 3)} )`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                            </div>

                         </div>

                          <div style="display: flex; flex-direction: column;  margin-bottom: 5px;">

                            <div v-if="main_bill_part" style="display:flex; align-items: center; justify-content:center; background: #eee;">

                              <div>
                                {{ main_bill_part.deposit_name }}
                              </div>

                              <div style="display:flex; align-items: center; margin-left:10px;">
                                <input v-if="!bill_part_setted" type="text" v-model="summ_bill_part_pre" style="background-color: white; padding:5px; width:100px;" />
                                <input v-else type="text" v-model="summ_bill_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                                <div style="
                                width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                                display: flex;
                                align-items: center;
                                justify-content: center;" >
                                  <div v-if="bill_part_setted" @click="setBillPart(false)">X</div>
                                  <div v-else @click="setBillPart(true)">OK</div>
                                </div>
                              </div>

                            </div>

                            <div v-if="main_bill_part2" style="display:flex; align-items: center; justify-content:center; background: #eee;">

                              <div>
                                {{ main_bill_part2.deposit_name }}
                              </div>

                              <div style="display:flex; align-items: center; margin-left:10px;">
                                <input v-if="!bill_part_setted2" type="text" v-model="summ_bill_part_pre2" style="background-color: white; padding:5px; width:100px;" />
                                <input v-else type="text" v-model="summ_bill_part_pre2" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                                <div style="
                                width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                                display: flex;
                                align-items: center;
                                justify-content: center;" >
                                  <div v-if="bill_part_setted2" @click="setBillPart2(false)">X</div>
                                  <div v-else @click="setBillPart2(true)">OK</div>
                                </div>
                              </div>

                            </div>

                          </div>

                        <div v-if="listBonus && listBonus.list && (credits.length == 1)" style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 80px;
                        ">
                          <div>Бонусные счета: </div>

                            <div style="padding-top: 20px;">
                              <v-select
                                  v-model="main_bonus_part"
                                  :rules="mainBonusRules"
                                  :items="listBonus ? listBonus.list : []"
                                  :item-text="item=>`${item.bonus_name} ( ${item.bonus_balance} ; Лимит:  ${item.bonus_limit} )`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                            </div>

                            <div v-if="main_bonus_part" style="display:flex; align-items: center; margin-left:10px;">
                              <input v-if="!bonus_part_setted" type="text" v-model="summ_bonus_part_pre" style="background-color: white; padding:5px; width:100px;" />
                              <input v-else type="text" v-model="summ_bonus_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                              <div style="
                              width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                              display: flex;
                              align-items: center;
                              justify-content: center;" >
                                <div v-if="bonus_part_setted" @click="setBonusPart(false)">X</div>
                                <div v-else @click="setBonusPart(true)">OK</div>
                              </div>
                            </div>

                        </div>

                      </v-btn-toggle>
                      <v-row style="margin:20px 0px;"><h3>Итого к оплате: {{ chosenAmountDebt }}</h3></v-row>
                      <hr>
                      
                      <v-row style="margin:10px 0px;">
                        <v-row>
                            <v-col>
                              <label>К оплате</label>
                              <v-text-field
                                  v-model="summ_cash_part"
                                  type="number"
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="success"
                                  readonly
                              >
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <label>Внесено</label>
                              <v-text-field
                                  v-model="cash_in_part"
                                  placeholder="0"
                                  type="number"
                                  hide-spin-buttons
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="#629F33"
                                  :readonly="(ifCashPay && !ifCardPay && !main_bonus_part && !main_bill_part) ? false : true"
                              >
                              
                              <!-- :rules="dialogTypeOfPayment === 0 ? (((+summ_cash_part) > 0) ? cashInRules : cashInFreeRules) : []" -->
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <label>Сдача</label>
                              <v-text-field
                                  v-model="cash_out_part"
                                  type="number"
                                  hide-spin-buttons
                                  readonly
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="#629F33"
                              >
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                      </v-row>
      
                      <v-row>
                        <v-col>
                          <div v-if="doingPayment" style="display:flex; align-items:center; margin-bottom:20px; justify-content:center;">
                                            <v-progress-circular
                                              color="green"
                                              indeterminate
                                              style="width:50px; height:50px;"
                                            ></v-progress-circular>
                          </div>
                          <v-btn
                              class="button button__success"
                              type="submit"
                              style="width: 100% !important; height: 48px !important;"
                              :disabled="isLoading || doingPayment"
                          >
                            Оплатить
                          </v-btn>
                          <v-btn
                              class="button button__danger"
                              @click="cancelReceipt"
                              style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                              :disabled="!doingPayment"
                          >
                            Отмена операции
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>

        </v-row>

        <!-- Enter Modal -->
        <v-row justify="center">
          <v-dialog
              v-model="enterModal"
              persistent
              max-width="540px"
          >
          <v-card rounded="lg" >
     
            <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4 style="font-weight:bold;">Выберите основание посещения</h4>
                </div>
                <v-btn icon @click="enterModal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>

                <v-card-text>
                  <v-container>
                      <div v-for="service in visitorDesktop.client.productes" :key="service.product_id" >
                        <div v-if="service.product_type === 'Членство' && service.product_status === 'Активен'" style="display:flex; align-items: center; justify-content: space-between;">
                            <div style="width:300px; font-size:18px;">{{service.product_name}}</div>
                            <div>
                                <v-switch
                                    style=""
                                    color="#629F33"
                                    inset
                                    @change="changeEnterServiceId(service.product_id)"
                                ></v-switch>
                            </div>
                        </div>
                      </div>
                      <v-row>
                        <v-col>
                          <v-btn
                              class="button button__success"
                              style="width: 100% !important; height: 48px !important;"
                              @click="exitButtonTap"
                          >
                            Вход
                          </v-btn>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-card-text>

          </v-card>
          </v-dialog>
         </v-row>
         <!-- Enter Modal -->

         <!-- Enter Modal -->
        <v-row justify="center">
          <v-dialog
              v-model="scanCardModal"
              persistent
              max-width="540px"
          >
          <v-card rounded="lg" >
            <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4 style="font-weight:bold;">Была отсканирована карта (браслет):</h4>
                  <span style="font-weight:bold; color:red;"> {{ card_scan_id }}</span>
                </div>
                <v-btn icon @click="scanCardModal = false, card_scan_id = null" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
          </v-card>
          </v-dialog>
         </v-row>
         <!-- Enter Modal -->

             <!-- Enter Modal -->
        <v-row justify="center">
          <v-dialog
              v-model="dialogNote"
              persistent
              max-width="540px"
          >
          <v-card rounded="lg" >
     
            <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4 style="font-weight:bold;">Новая заметка</h4>
                </div>
                <v-btn icon @click="dialogNote = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>

                <v-card-text>
                  <v-container>
                      <div >
                        <v-textarea
                            v-model="noteNew"
                            :rules="noteRules"
                            rounded
                            outlined
                            dense
                            required
                            auto-grow
                            background-color="#fff"
                            rows="5"
                            style="width: 100%; height: 150px"
                        ></v-textarea>

              
                      </div>
                      <v-row>
                        <v-col style="text-align:end;">
                          <v-btn
                              class="button button__success"
                              style="font-size: 13px; font-weight: 700; padding: 8px 20px !important; align-content: center"
                              @click="noteNewAdd"
                          >
                            Добавить
                          </v-btn>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-card-text>

          </v-card>
          </v-dialog>
         </v-row>

         <!-- return modal -->

         <v-row justify="center">
          <v-dialog
              v-model="dialogBillReturn"
              persistent
              max-width="540px"
          >

            <v-form
                ref="formBillReturn"
                v-model="validDialogBillReturn"
            >
              <v-card rounded="lg">
                <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Возврат</h4>
                  </div>
                  <v-btn icon @click="dialogBillReturn = false">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row class="d-flex justify-space-between mt-5">
                      <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                        <span class="payment-text">Чек на</span>
                      </div>
                      <div style="width: 65%">
                        <v-btn-toggle
                            mandatory
                            background-color="white"
                            class="mx-4 rounded-lg"
                            v-model="dialogTypeSender"
                        >
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-phone-incoming-outline
                            </v-icon>
                            Телефон
                          </v-btn>
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-email-outline
                            </v-icon>
                            Эл. почту
                          </v-btn>
                        </v-btn-toggle>
                      </div>
                    </v-row>

                    <v-btn-toggle
                        v-model="dialogTypeOfPayment"
                        mandatory
                        background-color="#FFFFFF"
                        class="rounded-lg"
                        style="margin-top: 40px; width: 100%"
                    >
                      <v-btn width="50%">
                        Наличные
                      </v-btn>
                      <v-btn width="50%">
                        Карта
                      </v-btn>
                    </v-btn-toggle>
                    <v-row class="mt-5">
                      <v-col cols="12">
                        <label>Касса </label>
                            <span style="color:red;" v-if="!listCashbox || listCashbox.length == 0">  (касса не подключена)</span>
                            <span v-else> ({{sale.org.legal_entity}} ({{sale.org.inn}}) )</span>
                        <v-select
                        v-if="listCashbox && listCashbox.length > 0"
                            v-model="cashbox_debit"
                            :rules="cashboxRules"
                            :items="listCashbox"
                            item-text="legal_entity"
                            item-value="serial"
                            class="rounded-lg"
                            label="Выбрать"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            hide-details
                            dense
                            required
                            color="#629F33"
                        ></v-select>

               
                        <v-select
                            v-else
                            v-model="cashbox_debit"
                            :items="listOrganizations.sales"
                            item-value="inn"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            hide-details
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        ></v-select>

                      </v-col>
                      <v-col cols="12">
                        <label>Л/С</label>
                        <v-select
                            v-model="bill_debit"
                            :rules="mainBillRules"
                            :items="listBill ? listBill.list : []"
                            item-text="deposit_name"
                            item-value="deposit_id"
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            label="Выбрать"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            color="#629F33"
                            return-object
                            @change="changeReturnBill()"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <label>Внесено</label>
                        <v-text-field
                            v-model="summ_return_bill"
                            :rules="makeSummRules"
                            placeholder="0"
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                            readonly
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <label>К возврату</label>
                        <v-text-field
                            v-model="summ_return_bill_result"
                            :rules="makeSummRules"
                            placeholder="0"
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
        
                    </v-row>

                    <v-row v-if="trans_show">
                      <v-col>
                        <label>Номер транзакции:</label>
                        <v-text-field
                            v-model="bill_hand_transaction_number"
                            placeholder=""
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                        >
                     
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="!trans_show && dialogTypeOfPayment === 1">
                      <v-col>
                        <div style="cursor:pointer;" @click="trans_show = true">
                          Ввести номер транзакции
                        </div>

                      </v-col>
                    </v-row>
                    
                    <v-row>
                      <v-col>
                        <v-btn
                            class="button button__success"
                            style="width: 100% !important; height: 48px !important;"
                            type="button"
                            @click="submitFormBillReturn"
                            :disabled="isLoadingCashbox || isLoadingAccount || isLoading2"
                        >
                          Вернуть оплату
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-form>
          </v-dialog>
        </v-row>

         <!-- Enter Modal -->

          </v-container>
          <v-container class="col-10" style="display:flex; flex-direction:column; align-items:center; justify-content: center; padding-top:300px;" v-else>
            <v-row><h3>Загрузка данных</h3></v-row>
            <v-row>
            <v-progress-circular
              color="green"
              indeterminate
              style="width:200px; height:200px;"
            ></v-progress-circular>
          </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>


</template>

<script>
import {clientActionTypes} from '@/store/modules/client';
import {accountActionTypes} from '@/store/modules/account';
import {receptionActionTypes} from '@/store/modules/reception';
import {notesActionTypes} from '@/store/modules/notes';
import {relativesActionTypes} from '@/store/modules/relatives';
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {billActionTypes} from "@/store/modules/bill";
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {salesActionTypes} from "@/store/modules/sale";
import {returnActionTypes} from '@/store/modules/return';

export default {
  name: 'Desktop',
  props: ['client_id','card_scan_id','save_search_data', 'to_bill_return'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      dialogNote:false,
      noteNew:'',
      date_birthday: new Date(),
      exitButtonText: "",
      date: new Date(),
      dateRules: [
        v => !!v || 'Дата рождения обязательное поле'
      ],
      valid: true,
      validDialogPayment: true,
      first_name: '',
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      middle_name: '',
      middleNameRules: [
        v => !!v || 'Фамилия обязательное поле'
      ],
      last_name: '',
      lastNameRules: [
        v => !!v || 'Отчество обязательное поле'
      ],
      gender: '',
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      genderTypes: [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      email: '',
      emailRules: [
        v => !!v || 'Электронная почта обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      relative_type: '',
      relativeTypeRules: [
        v => !!v || 'Степень родства обязательное поле'
      ],
      is_representative: false,
      bill_debit: null,
      mainBillRules: [
        v => !!v || 'Лицевой счет обязательное поле'
      ],
      bonus_bill: '',
      bonusBillRules: [
        v => !!v || 'Бонусный счет обязательное поле'
      ],
      billTypes: [
        {type_id: 1, type_name: 'Общий'},
        {type_id: 2, type_name: 'Раздельный'},
      ],
      select: null,
      selectRules: [
        v => !!v || 'Нужно выбрать родственника'
      ],
      card_number: null,
      card_number_par:null,
      cardNumberRules: [
        v => !!v || 'Номер карты обязательное поле'
      ],
      note: null,
      noteRules: [
        v => !!v || 'Заметки обязательное поле'
      ],
      makeSummRules: [
        v => !!v || 'Сумма обязательная'
      ],
      main_bill_debit: null,
      mainBillDebtRules: [
        v => !!v || 'Нужно выбрать Л/С',
        v => v?.deposit_balance >= this.chosenAmountDebt || 'Сумма Л/С должна быть больше суммы к оплате'
      ],
      cashbox_debit: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      chosenCard: null,
      unsetClient: true,
      isLoading2: false,
      isClicked: false,
      counterInterval: null,
      dialog: false,
      dialogCard: false,
      dialogCardEdit: false,
      dialogRelationEdit: false,
      dialogPayment: false,
      dialogDebitPayment: false,
      check_to: 0,
      dialogDebitTypeOfPayment: null,
      billTypeChosed: 0,
      dialogDeleteNote: false,
      editNoteStatus: false,
      editNoteId: null,
      deleteNoteId: null,
      editRelationItems: {
        id: null,
        name: '',
        relative_type: '',
        main_bill: '',
        bonus_bill: '',
        is_representative: false,
      },
      dialogTypeOfPayment: 0,
      dialogTypeSender: 0,
      search: '',
      tab: null,
      items: [
        {tab: 'Членства (Пакеты услуг)'},
        {tab: 'Родственники'},
        {tab: 'Заметки'},
      ],
      headersCredit: [
        {
          text: 'Услуги, товары',
          align: 'start',
          sortable: false,
          value: 'buy.buy_name'
        },
        {text: 'Сумма', value: 'amount_debt', width: '20%'}
      ],
      headersSubscribe: [
        {
          text: 'Членства и пакет',
          align: 'start',
          sortable: false,
          value: 'product_name',
          width: '75%'
        },
        {text: 'Активен по', value: 'product_lastdate', width: '15%'},
        {text: 'Статус', value: 'status_description', width: '15%'},
        {text: 'Остаток', value: 'product_balance', width: '10%'},
        {text: 'Действия', value: 'actions', sortable: false, width: '5%'},
      ],
      headersService: [
        {
          text: 'Услуга',
          align: 'start',
          sortable: false,
          value: 'service_name',
          width: '75%'
        },
        {text: 'Остаток', value: 'service_balance', width: '20%'},
        {text: 'Действия', value: 'actions', sortable: false, width: '5%'},
      ],
      headersVisits: [
        {text: 'Вход', value: 'date_start', width: '20%'},
        {text: 'Выход', value: 'date_end', width: '20%'},
        {text: 'В клубе', value: 'duration', width: '20%'},
        {text: 'Основание', value: 'aa', width: '40%'},
      ],
      headersAccount: [
        {
          text: 'Тип',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '70%'
        },
        {
          text: 'Сумма',
          align: 'start',
          sortable: false,
          value: 'balance',
          width: '30%'
        },
      ],
      headersRelations: [
        {
          text: 'ФИО',
          align: 'start',
          sortable: false,
          value: 'full_name',
          width: '40%'
        },
        {
          text: 'Степень родства',
          align: 'start',
          sortable: false,
          value: 'relatives_type.name',
          width: '30%'
        },
        {
          text: 'Телефон',
          align: 'start',
          sortable: false,
          value: 'phone',
          width: '30%'
        },
      ],
      headersNotes: [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'id',
          width: '5%'
        },
        {
          text: 'Заметка',
          align: 'start',
          sortable: false,
          value: 'note',
          width: '45%'

        },
        {
          text: 'Сотрудник',
          align: 'start',
          sortable: false,
          value: 'full_name',
          width: '35%'

        },
        {text: 'Действия', value: 'actions', sortable: false},
      ],
      headersRents:[
        {text: 'Тип', value: 'type_locker.name'},
        {text: 'Номер', value: 'locker.name'},
        {text: 'Дата с', value: 'date_time_start'},
        {text: 'Дата по', value: 'date_time_end'},
      ],
      credits: [],
      make_summ: null,
      summ_contributed: null,
      odd_money: 0,
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      listCreditCashbox: [],
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      dialogOfPaymentPart:false,
      //summ_cash_part:0,
      summ_card_part:0,
      summ_bill_part:0,
      summ_bill_part2:0,
      summ_part:0,
      main_bill_part_pre:0,
      summ_cash_part_pre:0,
      summ_card_part_pre:0,
      summ_bill_part_pre:0,
      summ_bill_part_pre2:0,
      cash_in_part_pre:0,
      cash_in_part_setted:false,
      card_part_setted:false,
      bill_part_setted:false,
      bill_part_setted2:false,
      bonus_part_setted:false,
      main_bonus_part:null,
      summ_bonus_part_pre:0,
      ifCardPay:false,
      ifCashPay:false,
      cash_in: null,
      cashInRules: [
        v => (v >= 0) || 'Введите внесенную сумму',
        v => parseInt(v) !== 0 || 'Введите внесенную сумму',
        v => !!v || 'Введите сумму'
      ],
      cash_out: 0,
      cash_from_bill: 0,
      cash_in_part: 0,
      cash_out_part: 0,
      cashFromBillRules: [
        v => parseInt(v) <= this.main_bill?.deposit_balance || 'Введите сумму не больше Л/С'
      ],
      buy_id_payment: null,
      sale: {
        number: null,
        date: new Date(),
        org: null,
        promocode: null,
      },
      listCashboxDef:[
        {
            inn:"1650387117",
            legal_entity:"OOO",
            serial:"0010872001250"
        },
        {
            inn:"165038711733",
            legal_entity:"IP",
            serial:"0010872001250333"
        }
      ],
      saleOrg:null,
      dialogTypeOfPaymentPart:[0,1,2,3],
      main_bill: null,
      main_bill_part_def:null,
      main_bill_part:null,
      main_bill_part2:null,
      mainBonusRules: [
        v => !!v || 'Нужно выбрать бонусный счет',
        v => parseInt(v.bonus_balance) !== 0 || 'Нулевой баланс счёта'
       // v => parseInt((v.bonus_limit*this.summ_cash_part)/100) >= this.summ_bonus_part_pre || 'Превышен лимит'
      ],
      sale_org_changed:false,
      enterModal:false,
      serviceEnterType:null,
      minDate: `${new Date().getFullYear()}-${new Date().getMonth()}-1`,
      maxDate: `${new Date().getFullYear()}-${new Date().getMonth()}-1`,
      openParentLine: [],
      scanCardModal:false,
      dialogBillReturn:false,
      validDialogBillReturn:true,
      summ_return_bill:0,
      summ_return_bill_result:0,
      trans_show:false,
      bill_hand_transaction_number:null,
      transaction_id_result:null,
      niceBill:null,
      credLengthRes:[],
      relative_adding:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      isLoadingDesktop: state => state.reception.isLoading,
      isLoadingCashbox: state => state.cashbox.isLoading,
      isLoadingAccount: state => state.account.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      listClient: state => state.client.listClient,
      listVisitor: state => state.reception.listVisitor,
      listBill: state => state.bill.list,
      listBillNew: state => state.bill.listnew,
      listBonus: state => state.bill.bonus,
      visitorDesktop: state => state.reception.visitorDesktop,
      validationErrors: state => state.reception.validationErrors,
      card: state => state.client.card,
      listNotes: state => state.notes.listNotes,
      listRelatives: state => state.relatives.listRelatives,
      listRelativesTypes: state => state.relatives.listRelativesTypes,
      userType: state => state.userType, //Роль пользователя
      userFIO: state => state.userFIO,
      listOrganizations: state => state.sale.listOrganizations
    }),
    chosenAmountDebt() {
      let total = 0;
      for (let debt of this.credits) {
        total += debt.amount_debt;
      }
      return total
    },
    summ_cash_part() {
      let total = 0;
      for (let debt of this.credits) {
        total += debt.amount_debt;
      }
      return total
    },
    totalAmountDebt() {
      let total = 0;
      for (let debt of this.visitorDesktop.client.debts) {
        total += debt.amount_debt;
      }
      return total
    }
  },
  methods: {
    changeReturnBill(){
      console.log(this.bill_debit)
      this.summ_return_bill = this.bill_debit.deposit_balance
      this.bill_hand_transaction_number = null
      this.trans_show = false
    },
    openChildren(id) {
      if (this.openParentLine.includes(id)) {
        this.$delete(this.openParentLine, this.openParentLine.indexOf(id))
      } else {
        this.$set(this, 'openParentLine', [...this.openParentLine, id])
      }

      console.log(this.openParentLine)
    },
    saveClientSearchCustom(client){
        this.$store.dispatch(clientActionTypes.saveSearchClient, {
          client_id: client.client_id,
          phone: client.phone,
          fio: client.name
        })
          .then((resp) => {
            console.log(resp)
        })
    },
    saveClientSearch(client){
        this.$store.dispatch(clientActionTypes.saveSearchClient, {
          client_id: this.client_id,
          phone: client.client.phone,
          fio: client.client.name
        })
          .then((resp) => {
            console.log(resp)
        })
    },
    changeEnterServiceId(item){
      this.serviceEnterType = item
    },
    makePaymentPart() {
      console.log(this.chosenAmountDebt)
      console.log('Оплата старт')
      console.log(this.credits)
      console.log('makePARTPayment')
      console.log(this.main_bonus_part)
      console.log(this.main_bill_part)
      //return;
      console.log(this.cashboxTerminal)
      console.log(this.dialogTypeOfPayment)
      console.log(this.sale.org)

      console.log('--')
      console.log(this.cash_in_part)
      console.log(this.cash_in_part_pre)
      console.log(this.summ_card_part_pre)
      console.log(this.summ_bill_part_pre)
      console.log(this.summ_bonus_part_pre)
      console.log('--')

      
      let to_pay = null
      let to_credit = null

      if(this.credits && this.credits.length === 1){

        if(this.credits[0]['amount_payment'] && this.credits[0]['amount_payment'] > 0){
          to_credit = this.credits[0]['amount_debt']
        }
     
      } else if (this.credits && this.credits.length > 1) {

        for (let i = 0; i<this.credits.length; i++){

          if(+this.credits[i].amount_payment > 0){
            alert(this.credits[i].buy.buy_name+'. Частично оплаченный документ должен быть оплачен отдельным чеком!')
            this.credits.splice(i, 1); 
            return;
          }

          // if(JSON.parse(getItem('select_org-sale'))){
          //   let org = JSON.parse(getItem('select_org-sale'));
          //   let serial = org.serial
          //   let inn = org.inn

          //   if(this.credits[i].org.org_inn !== inn){
          //     alert(this.credits[i].buy.buy_name+'. Нельзя оплатить в ввыбранной кассе!')
          //     this.credits.splice(i, 1); 
          //   }

          // } else if(this.listCashbox && this.listCashbox.length > 0){
          //   let inn = this.listCashbox[0].inn
          //   if(this.credits[i].org.org_inn !== inn){
          //     alert(this.credits[i].org.org_inn+'. Нельзя оплатить в ввыбранной кассе!')
          //     this.credits.splice(i, 1);
          //   }
          // }


        }
        
      }

  
      //return;

      let typeOfPartPayment = []

      if(!this.cash_in_part || this.cash_in_part <= 0){
        alert('Итоговая сумма внесено меньше суммы оплаты!');
        return;
      }

      if(Math.abs(this.chosenAmountDebt) > Math.abs(this.cash_in_part)){

        if (confirm("Итоговая сумма внесено меньше суммы оплаты! Продолжить?") == true) {
          console.log('continue')
          to_pay = this.cash_in_part
        } else {
          return;
        }

      }

      if(this.summ_card_part_pre && +this.summ_card_part_pre > 0) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            //return;
          }
      }

      if(this.cash_in_part_pre && (+this.cash_in_part_pre > 0) && !this.cash_in_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты наличными!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.cash_in_part_pre && (+this.cash_in_part_pre > 0)){
        typeOfPartPayment.push(0)
      }

      if(this.summ_card_part_pre && (+this.summ_card_part_pre > 0) && !this.card_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты картой!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_card_part_pre && (+this.summ_card_part_pre > 0)){
        typeOfPartPayment.push(2)
      }

      if(this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0) && !this.bill_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0)){
        typeOfPartPayment.push(1)
      }

      if(this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0) && !this.bill_part_setted2) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта 2!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0)){
        typeOfPartPayment.push(7)
      }

      if(this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0) && !this.bonus_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с бонусного счёта!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0)){
        this.main_bonus_part.val = this.summ_bonus_part_pre
        typeOfPartPayment.push(3)
      }

      console.log(typeOfPartPayment)

      //return;


      //if (this.$refs.form.validate()) {
        console.log('summ to 1C:  ' + Math.abs(this.summForPaymentPart))
        console.log('summ to 1C:  ' + Math.abs(this.summ_part))

          if(this.main_bill_part && +this.summ_bill_part_pre > this.main_bill_part.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bill_part2 && +this.summ_bill_part_pre2 > this.main_bill_part2.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bonus_part && +this.summ_bonus_part_pre > this.main_bonus_part.bonus_balance){
            alert('Сумма списания с бонусного счёта превышает остаток на балансе счёта!');
            return;
          }


        if(!this.sale || !this.sale.org|| !this.sale.org.inn) {
          alert('Не подключена или не выбрана касса!');
        }

        console.log(this.cash_in_part_pre)
        console.log(this.summ_card_part_pre)
        console.log(typeOfPartPayment)
        console.log(this.client)
        console.log(this.client_id)

        console.log('-----------------------------------------')
        console.log(to_pay)
        console.log(to_credit)
        console.log(this.credits)

        //return

        //if (this.$refs.creditsForm.validate()) {
          this.$store.dispatch(cashboxActionTypes.multiplePaymentMany, {
            cashbox_list: this.listCashbox,
            client_id: this.client_id,
            type: typeOfPartPayment,
            bill_id: (this.summ_bill_part_pre && +this.summ_bill_part_pre > 0) ? this.main_bill_part?.deposit_id : null,
            bill_id2: (this.summ_bill_part_pre2 && +this.summ_bill_part_pre2 > 0) ? this.main_bill_part2?.deposit_id : null,
            terminal_id: (this.summ_card_part_pre && +this.summ_card_part_pre > 0) ? this.cashboxTerminal : null,
            fio: this.userFIO,
            credit_list: this.credits,
            till_id: this.sale.org.serial,
                    cash: this.cash_in_part_pre,
                    card: this.summ_card_part_pre,
                    bill: this.summ_bill_part_pre,
                    bill2: this.summ_bill_part_pre2,
                    bonus: this.summ_bonus_part_pre,
                    bonus_obj: this.main_bonus_part,
                    summ: Math.abs(this.chosenAmountDebt),
                    to_pay: to_pay,
                    to_credit: to_credit
          })
              .then((response) => {
                if (response.success) {
                  this.fetchFeed(this.client_id);
                  this.dialogDebitPayment = false;
                  this.main_bill_debit = null;
                  this.chosenAmountDebt = 0;
                  this.credits = [];
                  this.dialogOfPaymentPart = false
                }
              })
        //}

    },
    toCashPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCashPay){
        this.ifCashPay = false
        
        
        if(this.cash_in_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        }
        this.cash_in_part_setted = false
        this.cash_in_part_pre = 0
      } else {
        this.cash_in_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCashPay = true
      }
    },
    toCardPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCardPay){
        this.ifCardPay = false
        
        
        if(this.card_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        }
        this.card_part_setted = false
        this.summ_card_part_pre = 0
      } else {
        this.summ_card_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCardPay = true
      }
    },
    ChangeSaleOrg(){
      this.sale_org_changed = true
    },
    setCashPart(status){
      if((+this.cash_in_part >= +this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        this.ifCashPay = false
        return;
      }
      if(+this.cash_in_part_pre > 0){
        this.cash_in_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.cash_in_part_pre)) : (this.cash_in_part - (+this.cash_in_part_pre))
      } else {
        this.cash_in_part_pre = 0
      }
      if(!status){
        this.ifCashPay = false
      }
    },
    setCardPart(status){
      if((+this.cash_in_part >= +this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        this.ifCardPay = false
        return;
      }
      if(+this.summ_card_part_pre > 0){
        this.card_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_card_part_pre)) : (this.cash_in_part - (+this.summ_card_part_pre))
      } else {
        this.summ_card_part_pre = 0
      }
      if(!status){
        this.ifCardPay = false
      }
    },
    setBillPart(status){
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bill_part = null
        this.canAddSumm = false
      }
      if(+this.summ_bill_part_pre > 0){
        this.bill_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre)) : (this.cash_in_part - (+this.summ_bill_part_pre))
      } else {
        this.summ_bill_part_pre = 0
      }

    },
    setBillPart2(status){
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bill_part2 = null
        this.canAddSumm = false
      }
      if(+this.summ_bill_part_pre2 > 0){
        this.bill_part_setted2 = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre2)) : (this.cash_in_part - (+this.summ_bill_part_pre2))
      } else {
        this.summ_bill_part_pre2 = 0
      }

    },
    setBonusPart(status){
      // if(+this.summ_bonus_part_pre > 0){
      //   this.bonus_part_setted = status
      //   this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bonus_part_pre)) : (this.cash_in_part - (+this.summ_bonus_part_pre))

      // } else {
      //   this.summ_bonus_part_pre = 0
      // }
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bonus_part = null
        this.canAddSumm = false
      }
      if(this.summ_bonus_part_pre > this.main_bonus_part.bonus_limit){
        alert('Превышен лимит по бонусному счёту!')
        this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
        this.bonus_part_setted = false
      }
      if(+this.summ_bonus_part_pre > 0){
        this.bonus_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bonus_part_pre)) : (this.cash_in_part - (+this.summ_bonus_part_pre))

      } else {
        this.summ_bonus_part_pre = 0
      }
    },
    allCredits(){
      console.log('aall')
      console.log(this.credits)
    },
    setCashboxTerminal(){
      let serial = (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : "00108723658089"
      if (JSON.parse(getItem('select_org-sale'))) {
        let org = JSON.parse(getItem('select_org-sale'));
        serial = org.serial
      }
      if(this.cashbox){
        serial = this.cashbox
      }
      // if(!this.listCashbox || !this.listCashbox[0]){
      //   alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      // } 
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: serial
      }).then((resp) => {
       console.log(resp)
       if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
          this.cashboxTerminal = resp.cashbox.terminals[0].id
       } 
      //  else {
      //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
      //  }
      })
    },
    fetchFeedCustom4(client_id) {

      console.log('fetchFeedCustom44444')

      this.client_id = client_id;
      setItem('desktop-client_id', this.client_id);
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id:client_id,ttt:true}).then((res) => {
        if (!res || !res.success) {
          this.$router.push({name: 'Clients', params: {}})
        } else {
          if (this.dialog || this.dialogRelationEdit) {
            this.dialog = false;
            this.dialogRelationEdit = false
          }

          if(this.card_scan_id){  
            this.scanCardModal = true
          } 

          this.$store.dispatch(notesActionTypes.getNotesList, {
            client_id: this.client_id
          });


        }
        if (this.visitorDesktop.client.last_visit.active == true) {
          this.exitButtonText = "Выход";
        } else {
          this.exitButtonText = "Вход";
        }
        if(res) {
          //save client search data
          this.saveClientSearch(res)
        }

      }).catch(error => {
        //this.$router.push({name: 'Clients', params: {}})
      });
      if (this.tab === 1) {
        this.$store.dispatch(relativesActionTypes.getRelativesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 2) {
        this.$store.dispatch(notesActionTypes.getNotesList, {
          client_id: this.client_id
        });
      }
      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});
    },
    fetchFeedCustom(client_id) {

      console.log('fetchFeedCustom')

      this.client_id = client_id;
      setItem('desktop-client_id', this.client_id);
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id:client_id,ttt:true}).then((res) => {
        if (!res || !res.success) {
          this.$router.push({name: 'Clients', params: {}})
        } else {
          if (this.dialog || this.dialogRelationEdit) {
            this.dialog = false;
            this.dialogRelationEdit = false
          }

          if(this.card_scan_id){  
            this.scanCardModal = true
          } 

          this.$store.dispatch(notesActionTypes.getNotesList, {
            client_id: this.client_id
          });


        }
        if (this.visitorDesktop.client.last_visit.active == true) {
          this.exitButtonText = "Выход";
        } else {
          this.exitButtonText = "Вход";
        }
        if(res) {
          //save client search data
          //this.saveClientSearch(res)
        }

      }).catch(error => {
        //this.$router.push({name: 'Clients', params: {}})
      });
      if (this.tab === 1) {
        this.$store.dispatch(relativesActionTypes.getRelativesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 2) {
        this.$store.dispatch(notesActionTypes.getNotesList, {
          client_id: this.client_id
        });
      }
      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});
    },
    fetchFeed(client_id) {
      this.client_id = client_id;
      setItem('desktop-client_id', this.client_id);
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id:client_id,ttt:true}).then((res) => {
        if (!res || !res.success) {
          this.$router.push({name: 'Clients', params: {}})
        } else {
          if (this.dialog || this.dialogRelationEdit) {
            this.dialog = false;
            this.dialogRelationEdit = false
          }

          if(this.card_scan_id){  
            this.scanCardModal = true
          } 

          this.$store.dispatch(notesActionTypes.getNotesList, {
            client_id: this.client_id
          });


        }
        if (this.visitorDesktop.client.last_visit.active == true) {
          this.exitButtonText = "Выход";
        } else {
          this.exitButtonText = "Вход";
        }
        // if(res) {
        //   //save client search data
        //   this.saveClientSearch(res)
        // }

      }).catch(error => {
        //this.$router.push({name: 'Clients', params: {}})
      });
      if (this.tab === 1) {
        this.$store.dispatch(relativesActionTypes.getRelativesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 2) {
        this.$store.dispatch(notesActionTypes.getNotesList, {
          client_id: this.client_id
        });
      }
      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});
    },
    fetchFeedCard(card_id) {
      this.card_number = card_id;
      this.card_number_par = card_id;
      this.isClicked = false;
    },
    stopCard(){
      clearInterval(this.counterInterval)
      this.$emit('stopInterval', 1)
    },
    searchBracelet() {
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    searchBraceletPar(){
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    exitButton(){
      if(this.visitorDesktop.client.last_visit.active == true){
        this.exitButtonTap()
      } else {
        let prodAct = []

        if(this.visitorDesktop.client.productes && this.visitorDesktop.client.productes.length > 0){

          for(let j = 0; j < this.visitorDesktop.client.productes.length; j++){
            if(this.visitorDesktop.client.productes[j].product_services && this.visitorDesktop.client.productes[j].product_services.length > 0){
              for(let i = 0; i < this.visitorDesktop.client.productes[j].product_services.length; i++){
                if(this.visitorDesktop.client.productes[j].product_services[i].product_type === 'Членство' && this.visitorDesktop.client.productes[j].product_services[i].product_status === 'Активен'){
                  prodAct.push(this.visitorDesktop.client.productes[j].product_services[i])
                }
              }
            }
        }

          if(prodAct.length === 0) {
            alert('Нет оснований для посещений!')
          } else {
            if(prodAct.length === 1){
              this.changeEnterServiceId(prodAct[0].product_id)
              this.exitButtonTap()
            } else {
              this.enterModal = true
            }
            console.log('пускаем')
          }

        } else {
          alert('Нет оснований для посещений!')
        }
        
        console.log(prodAct)
        
      }
    },
    exitButtonTap() {
      let fine = null

      if(this.visitorDesktop.client.fines && this.visitorDesktop.client.fines.sum){
        fine = (this.visitorDesktop.client.last_visit.active == true) ? true : null
      }

      this.$store.dispatch(clientActionTypes.changeClientStatus, {
        client_id: this.client_id,
        type: (this.visitorDesktop.client.last_visit.active == true) ? 'exit' : 'enter',
        product_id: this.serviceEnterType,
        fine: fine
      })
        .then(() => {
        this.enterModal = false
        this.fetchFeed(this.client_id)
      })
    },
    changeState(id) {
      if (id === true) {
        this.unsetClient = false;
      } else {
        this.unsetClient = true
      }
    },
    getRoute(status, product_id) {
      if (status === 'Активен') return {
        name: 'FreezePackage',
        params: {client_id: this.client_id, product_id: product_id}
      }
      else if (status === 'Заморожен') return {
        name: 'UnfreezePackage',
        params: {client_id: this.client_id, product_id: product_id}
      }
      else {
        return {}
      }
    },
    getNameStatus(status) {
      if (status === 'Активен') return 'Заморозить'
      else if (status === 'Заморожен') return 'Разморозить'
      else if (status === 'Продан') return 'Активировать'
      else if (status === 'Закрыт') return 'Закрыт'
    },
    activateProduct(item) {
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: item,
        client_id: this.client_id
      })
          .then(() => {
            this.fetchFeed(this.client_id)
          })
    },
    formatDate(data) {
      
      let date = data.date_end
      let descr = ''

      if(data.date_end.split('T'[1])){
        date = data.date_end.split('T')[0] + ' ' + data.date_end.split('T')[1]
      }

      if(data.description) {
        descr = data.description
      }

      return descr

    },
    // modalBillPayment() {
    //   this.cashbox_debit = this.listCashbox[0].serial;
    //   this.$store.dispatch(billActionTypes.getListBill, {
    //     client_id: this.client_id
    //   }).then((response) => {
    //     if (response.success) {
    //       this.dialogPayment = true;
    //     }
    //   });
    // },
    modalBillPayment() {
      console.log(this.listCashbox)
      if(!this.listCashbox || this.listCashbox == null){
        alert('Не выбрана касса!')
      } else {
        this.cashbox_debit = this.listCashbox[0].serial;
      }
      this.dialogPayment = true;
      
      this.$store.dispatch(billActionTypes.getListBill,{client_id: this.client_id});

      this.$store.dispatch(billActionTypes.getListBillNew,{client_id: this.client_id});
    },
    submitFormBillReturn() {
      if (this.$refs.formBillReturn.validate()) {
        console.log(this.bill_debit)
        console.log(this.summ_return_bill)
        console.log(this.summ_return_bill_result)
        console.log(this.cashbox_debit)
        console.log(this.dialogTypeOfPayment)
        console.log(this.listCashbox)
        console.log(this.sale)

        if(+this.summ_return_bill_result > this.summ_return_bill){
          alert('Не верная сумма к возврату!')
        }

        let serial = (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : "00108723658089"
        let serial2 = (this.sale && this.sale.org) ? this.sale.org.serial : null
        
        // terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,


        this.transaction_id_result = null
        this.niceBill = null

        if(this.dialogTypeOfPayment === 1){
          if(this.bill_debit){
            if(this.bill_debit.transactions && this.bill_debit.transactions[0] && this.bill_debit.transactions[0].transaction_id) {

              //let niceBill = null
              for(let i = 0; i < this.bill_debit.transactions.length; i++){
              let timeEnd = this.bill_debit.transactions[i].transaction_date
              if(timeEnd){
                          if(timeEnd.split('T')[0]){
                            let mmonth = timeEnd.split('T')[0].split('-')[1]
                            let dday = timeEnd.split('T')[0].split('-')[2]

                            let mmonth2 = new Date().getMonth() + 1;
                            let dday2 = new Date().getDate();

                            if(+mmonth < mmonth2){
                            } else if(+dday < dday2){
                        
                            } else if(+dday === dday2){
                              console.log('denj tot zhe')

                              let hhour2 = new Date().getHours(0)
                              let hhour = +timeEnd.split('T')[1].split(':')[0]

                              console.log(hhour2)
                              console.log(hhour)

                              this.niceBill = this.bill_debit.transactions[i].transaction_id

                            }

                          }
                        } 

                  }

                  console.log(this.niceBill)

                  if(!this.niceBill && !this.bill_hand_transaction_number) {
                    alert('Для данного внесения по карте были больше суток назад. Необходим ручной ввод номера транзакции.')
                    this.trans_show = true
                  }

            } else {
              alert('По выбранному счёту не было внесений платёжной картой!');
              return;
            }
          }


          if(this.trans_show && !this.bill_hand_transaction_number){
            alert('Не введён номер транзакции!');
            return;
          }

          this.transaction_id_result = this.bill_hand_transaction_number ? this.bill_hand_transaction_number : (this.niceBill ? this.niceBill : null)

        }

        console.log(this.transaction_id_result)

        this.isLoading2 = true

        this.$store.dispatch(returnActionTypes.returnReceipt, {
          return_from_bill:true,
          till_id: serial,
          till_id2: serial2,
          terminal_id: (this.dialogTypeOfPayment + 1) === 2 ? this.cashboxTerminal : null,
          bill_id:this.bill_debit.deposit_id,
          client_id: this.client_id,
          summ:this.summ_return_bill_result,
          transaction_type: this.dialogTypeOfPayment + 1,
          transaction_id: this.transaction_id_result
        })
          .then((response) => {
            this.isLoading2 = false
            if(response && response.success){
              alert('Успешный возврат!')
            } else {
              alert('Ошибка возврата!')
            }
            this.dialogBillReturn = false
          })
      } 
    },
    submitFormMakePayment() {

      console.log('submitFormMakePayment')
      console.log(this.cashbox_debit)
      
      if (this.$refs.formPayment.validate()) {
        this.$store.dispatch(cashboxActionTypes.saleReceipt, {
          till_id: this.cashbox_debit,
          type: this.dialogDebitTypeOfPayment === 1 ? 3 : 1,
          fio: this.userFIO,
          service_list: [
            {
              price: this.make_summ,
              sum: this.make_summ,
              discount: 0,
              count: 1,
              name: "Взнос на лицевой счет",
            }
          ]
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(accountActionTypes.makePayment, {
              client_id: this.client_id,
              bill_id: this.bill_debit,
              till_id: this.cashbox_debit,
              make_summ: this.make_summ,
              check_number: response.receipt_number,
              type: this.dialogDebitTypeOfPayment === 1 ? 3 : 1,
              terminal_id: this.dialogDebitTypeOfPayment === 1 ? this.cashboxTerminal : null,
              transaction_id: this.dialogDebitTypeOfPayment === 1 ? response.auth_code : null,
              transaction_date: this.dialogDebitTypeOfPayment === 1 ? new Date() : null,
              isNew:(this.billTypeChosed === 1) ? true : false
            })
                .then(() => {
                  this.fetchFeed(this.client_id)
                  this.dialogPayment = false;
                })
          }
        })

      }
    },
    addCard() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(clientActionTypes.cardAdd, {
          client_id: this.client_id,
          card_number: this.card_number,
        })
            .then(() => {
              this.fetchFeed(this.client_id)
              this.dialogCard = false;
            })
      }
    },
    unlock(card_id) {
      this.$store.dispatch(clientActionTypes.cardUnlock, {
        card_id: card_id
      })
          .then(() => {
            this.fetchFeed(this.client_id)
            this.dialogCardEdit = false;
          })
    },
    block(card_id) {
      this.$store.dispatch(clientActionTypes.cardBlock, {
        card_id: card_id
      })
          .then(() => {
            this.fetchFeed(this.client_id)
            this.dialogCardEdit = false;
          })
    },
    deleteCard(card_id) {
      this.$store.dispatch(clientActionTypes.cardDelete, {
        card_id: card_id
      })
          .then(() => {
            this.fetchFeed(this.client_id)
            this.dialogCardEdit = false;
          })
    },
    cardInfo(card) {
      this.chosenCard = card;
      let card_id = card.card_id
      this.$store.dispatch(clientActionTypes.cardInfo, {card_id})
      this.dialogCardEdit = true;
    },
    addRelation() {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.dialog = true;
    },
    addRelationSubmit() {
      if (this.$refs.relationForm.validate()) {
        if (this.unsetClient === true) {

          this.relative_adding = true

          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            phone: this.phone,
            first_name: this.first_name,
            last_name: this.last_name,
            middle_name: this.middle_name,
            date_birthday: this.date_birthday,
            gender: this.gender,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            unset_client: this.unsetClient,
            card_number: this.card_number_par
          })
              .then((response) => {

                this.relative_adding = false

                if(!response || !response.success || response.success == false) {
                  alert('Ошибка создания родственника (номер телефона уже существует)')
                }

                this.$store.dispatch(relativesActionTypes.getRelativesList, {
                  client_id: this.client_id
                });
                this.dialog = false;
              })
        } else {

          this.relative_adding = true

          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            relative_id: (this.select && this.select.client_id) ? this.select.client_id : this.select,
            unset_client: this.unsetClient
          })
              .then((response) => {

                this.relative_adding = false

                if(!response || !response.success || response.success == false) {
                  alert('Ошибка создания родственника (номер телефона уже существует)')
                }

                this.$store.dispatch(relativesActionTypes.getRelativesList, {
                  client_id: this.client_id
                });
                this.dialog = false;
              })
        }
      }
    },
    editRelation(item) {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.editRelationItems.id = item.id;
      this.editRelationItems.name = item.last_name + ' ' + item.first_name + ' ' + item.middle_name;
      this.editRelationItems.relative_type = item.relatives_type.id;
      this.editRelationItems.is_representative = item.is_representative;
      this.editRelationItems.main_bill = item.shared_main_bill ? 1 : 2;
      this.editRelationItems.bonus_bill = item.shared_bonus_bill ? 1 : 2;
      this.dialogRelationEdit = true;
    },
    editRelationSubmit() {
      this.$store.dispatch(relativesActionTypes.relativesEdit, {
        client_id: this.client_id,
        relative_id: this.editRelationItems.id,
        relative_type: this.editRelationItems.relative_type,
        is_representative: this.editRelationItems.is_representative,
        main_bill_type: this.editRelationItems.main_bill === 1,
        bonus_bill_type: this.editRelationItems.bonus_bill === 1
      })
          .then(() => {
            this.$store.dispatch(relativesActionTypes.getRelativesList, {
              client_id: this.client_id
            });
            this.dialogRelationEdit = false;
          })
    },
    deleteRelationSubmit() {
      this.$store.dispatch(relativesActionTypes.relativesRemove, {
        client_id: this.client_id,
        relative_id: this.editRelationItems.id,
      })
          .then(() => {
            this.$store.dispatch(relativesActionTypes.getRelativesList, {
              client_id: this.client_id
            });
            this.dialogRelationEdit = false;
          })
    },
    editNote(id, note) {
      this.editNoteStatus = true;
      this.editNoteId = id;
      this.note = note;
    },
    deleteNote(id) {
      this.deleteNoteId = id;
      this.dialogDeleteNote = true;
    },
    noteNewAdd(){
      if (this.noteNew && this.noteNew.length > 0) {
   
          this.$store.dispatch(notesActionTypes.notesAdd, {
            client_id: this.client_id,
            note: this.noteNew,
            type:1
          })
          .then(() => {
            this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
              this.note = '';
              this.noteNew = '';
              this.dialogNote = false
          })
      }
    },
    noteSubmit() {
      if (this.$refs.noteForm.validate()) {
        if (this.editNoteStatus === true) {
          this.$store.dispatch(notesActionTypes.notesEdit, {
            client_id: this.client_id,
            note_id: this.editNoteId,
            note: this.note
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
                this.editNoteStatus = false;
              })
        } else {
          this.$store.dispatch(notesActionTypes.notesAdd, {
            client_id: this.client_id,
            note: this.note,
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
              })
        }
      }
    },
    deleteNoteSubmit() {
      this.$store.dispatch(notesActionTypes.notesRemove, {
        client_id: this.client_id,
        note_id: this.deleteNoteId,
        type:1
      })
          .then(() => {
            this.$store.dispatch(notesActionTypes.getNotesList, {
              client_id: this.client_id
            });
            this.dialogDeleteNote = false;
          })
    },
    modalPayment() {
      console.log(this.credits)

     // this.dialogOfPaymentPart = true;

      this.main_bill_part_pre = 0
      this.summ_cash_part_pre = 0
      this.summ_card_part_pre = 0
      this.summ_bill_part_pre = 0
      this.cash_in_part_pre = 0
      this.cash_in_part_setted = false
      this.card_part_setted = false
      this.bill_part_setted = false
      this.bonus_part_setted = false

      this.ifCardPay = false
      this.ifCashPay = false

      this.cash_in_part = 0

      if(this.credits && this.credits.length === 1){

        for (let i = 0; i<this.credits.length; i++){

          // if(+this.credits[i].amount_payment > 0){
          //   alert(this.credits[i].buy.buy_name+'. Частично оплаченный документ должен быть оплачен отдельным чеком!')
          //   this.credits.splice(i, 1); 
          // }

          if(JSON.parse(getItem('select_org-sale'))){
            let org = JSON.parse(getItem('select_org-sale'));
            let serial = org.serial
            let inn = org.inn

            if(this.credits[i].org.org_inn !== inn){
              alert(this.credits[i].buy.buy_name+'. Нельзя оплатить в ввыбранной кассе!')
              this.credits.splice(i, 1); 
            }

          } else if(this.listCashbox && this.listCashbox.length > 0){
            let inn = this.listCashbox[0].inn
            if(this.credits[i].org.org_inn !== inn){
              alert(this.credits[i].org.org_inn+'. Нельзя оплатить в ввыбранной кассе!')
              this.credits.splice(i, 1);
            }
          }


        }

      } else if (this.credits && this.credits.length > 1) {

        for (let i = 0; i<this.credits.length; i++){

          if(+this.credits[i].amount_payment > 0){
            alert(this.credits[i].buy.buy_name+'. Частично оплаченный документ должен быть оплачен отдельным чеком!')
            this.credits.splice(i, 1); 
          }

          if(JSON.parse(getItem('select_org-sale'))){
            let org = JSON.parse(getItem('select_org-sale'));
            let serial = org.serial
            let inn = org.inn

            if(this.credits[i].org.org_inn !== inn){
              alert(this.credits[i].buy.buy_name+'. Нельзя оплатить в ввыбранной кассе!')
              this.credits.splice(i, 1); 
            }

          } else if(this.listCashbox && this.listCashbox.length > 0){
            let inn = this.listCashbox[0].inn
            if(this.credits[i].org.org_inn !== inn){
              alert(this.credits[i].org.org_inn+'. Нельзя оплатить в ввыбранной кассе!')
              this.credits.splice(i, 1);
            }
          }


        }

      }


      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      this.$store.dispatch(billActionTypes.getListBill, {
        client_id: this.client_id
      }).then((response) => {
   
      });

      if(this.credits.length == 1){
        this.$store.dispatch(billActionTypes.getListBonus,{
          client_id: this.client_id,
          buy_id:this.credits[0].buy.buy_id
        }).then((response) => {
          if (response.success) {
            this.dialogOfPaymentPart = true;
          }
        })
      } else {
        this.dialogOfPaymentPart = true;
      }

      this.summ_cash_part = this.chosenAmountDebt
      this.summ_part = this.chosenAmountDebt

      
    },
    makePayment() {

      console.log('makePayment')
      console.log(this.listCashbox)
      

      console.log(this.dialogTypeOfPayment)
      console.log(this.cashboxTerminal)

      if (this.$refs.creditsForm.validate()) {
        this.$store.dispatch(cashboxActionTypes.multiplePayment, {
          cashbox_list: this.listCashbox,
          type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
          bill_id: (this.dialogTypeOfPayment+1) === 1 ? this.main_bill_debit?.deposit_id : null,
          terminal_id: (this.dialogTypeOfPayment+1) === 3 ? this.cashboxTerminal : null,
          fio: this.userFIO,
          credit_list: this.credits
        })
            .then((response) => {
              if (response.success) {
                this.fetchFeed(this.client_id);
                this.dialogDebitPayment = false;
                this.main_bill_debit = null;
                this.chosenAmountDebt = 0;
                this.credits = [];
              }
            })
      }
    },
    cancelReceipt() {
      for (let cashbox of this.listCreditCashbox) {
        this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
          till_id: cashbox.serial,
          fio: this.userFIO
        })
      }
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          console.log('RESSS'+xmlhttp.responseText)
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
            if(xmlhttp.responseText.length>0)
            {
              if(!vm.cardRightNow)
              {
                var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                transformArray.reverse();
                var resultString = transformArray.length === 7 ? transformArray.join('') : transformArray.join('')+'000000';
                console.log(resultString);
                console.log('Card has been placed on reader: '+resultString); // action here!!!!

                //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                vm.fetchFeedCard(resultString);
                vm.cardRightNow = true;
              }
            }
            else
            {
              vm.counterInterval = setInterval(vm.sendRequest, 1000);
              if(vm.cardRightNow)
              {
                cardRightNow = false;
                console.log('no card');
                console.log('Card has been removed from reader: '); //card removed (may be needed in future)
              }
            }
          }
          else if (xmlhttp.status == 400) {
            console.log('There was an error 400');
          }
          else {
            console.log('something else other than 200 was returned');
          }

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    },
  },
  mounted() {
    
    setItem('schedule-service', null)
    setItem('schedule-client_id', null)
    setItem('schedule-client_name', null)
    setItem('schedule-search_client', null)
    setItem('schedule-select_client', null)
    setItem('sale-buy_id', null)
    setItem('sales-monitor-specialist_id', null);
    setItem('sales-monitor-specialist_type', null);
    setItem('sales-monitor-datetype', null);
    setItem('sales-monitor-datetype_date', null);

    setItem('report_12',null);
    setItem('report_13',null);
    setItem('report_14',null);
    setItem('report_15',null);
    setItem('report_16',null);
    setItem('report_17',null);
    
    setItem('report_newclient_id',null);

    setItem('sale-client',null)
    
    // this.client_id = null
    let ccl = getItem('desktop-client_id')

    if((!this.client_id || this.client_id === undefined || this.client_id === null) && (!ccl || ccl === undefined || ccl === null)){
      this.$router.push({name: 'Main', params: {}})
    }

    this.client_id !== undefined ? setItem('desktop-client_id', this.client_id) : this.client_id = getItem('desktop-client_id');
    if (this.client_id.split('000000').length > 1) {
      
      this.fetchFeedCard(this.client_id);

    } else {

      this.fetchFeed(this.client_id);

    }
    this.setCashboxTerminal()

    if (JSON.parse(getItem('select_org-sale'))) {
      this.sale.org = JSON.parse(getItem('select_org-sale'));
      this.saleOrg = JSON.parse(getItem('select_org-sale'));
    } else {
      this.sale.org = this.listCashbox ? this.listCashbox[0] : null;
      this.saleOrg = this.listCashbox ? this.listCashbox[0] : null;
    }

    // this.$store.dispatch(notesActionTypes.getNotesList, {
    //       client_id: this.client_id
    //     });

    console.log(JSON.parse(getItem('select_org-sale')))
    console.log(this.saleOrg)

    //this.modalPayment()

    if(this.save_search_data && this.save_search_data.client_id) {
      console.log(this.save_search_data)
      
      this.saveClientSearchCustom(this.save_search_data)
    }

    setItem('sale-buyer_saler',null)

    if(this.to_bill_return) {
      this.$store.dispatch(billActionTypes.getListBill,{client_id: this.client_id});
      this.dialogBillReturn = true
    }

  },
  watch: {
    tab() {
      if (this.tab === 1) {
        this.$store.dispatch(relativesActionTypes.getRelativesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 2) {
        this.$store.dispatch(notesActionTypes.getNotesList, {
          client_id: this.client_id
        });
      }
    },
    summ_contributed: function (value) {
      if (this.make_summ) {
        let odd_money = value - this.make_summ
        if (odd_money > 0) {
          this.odd_money = odd_money
        } else {
          this.odd_money = 0
        }
      }
    },
    search() {
      if (this.search !== '' || !this.isLoading) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      }
    },
    dialogCard() {
      if (!this.dialogCard) {
        this.stopCard()
      }
    },
    credits() {


      this.main_bill_part_pre = 0
      this.summ_cash_part_pre = 0
      this.summ_card_part_pre = 0
      this.summ_bill_part_pre = 0
      this.cash_in_part_pre = 0
      this.cash_in_part_setted = false
      this.card_part_setted = false
      this.bill_part_setted = false
      this.bonus_part_setted = false

      this.ifCardPay = false
      this.ifCashPay = false

      this.cash_in_part = 0

      //check paymented amount
      // if((this.credLengthRes.length > 0) && +this.credits[this.credits.length-1].amount_payment > 0){
      //   alert('Частично оплаченный документ должен быть оплачен отдельным чеком!')
      //   this.credits.pop();
      // }


      if(JSON.parse(getItem('select_org-sale')) && JSON.parse(getItem('select_org-sale')) !== null){

        console.log('касса была сохранена')

        let org = JSON.parse(getItem('select_org-sale'));
        let serial = org.serial
        let inn = org.inn

         if(this.credits[this.credits.length-1].org.org_inn !== inn){

          console.log('не та касса')

          if(this.listCashbox){

            console.log('ищем подходящую кассу для оплаты')

            let cresditCashboxes = this.listCashbox.filter(cashboxItem => {
              return this.credits.some(creditItem => cashboxItem.inn === creditItem.org.org_inn);
            });

            if(cresditCashboxes) {

              console.log('нашли кассу')

              this.sale.org = cresditCashboxes;
              this.listCreditCashbox = cresditCashboxes

            } else {

              alert('Нет подходящих касс для оплаты!')
              this.credits.pop();

            }

          } else {
            alert('Нет подходящих касс!')
            this.credits.pop();
          }


          // alert('Нельзя оплатить в ввыбранной кассе!')
          // this.credits.pop();
         }

      } else if(this.listCashbox && this.listCashbox.length > 0){

        console.log('касса не сохранена')


        // let inn = this.listCashbox[0].inn
        // if(this.credits[this.credits.length-1].org.org_inn !== inn){
        //   alert('Нельзя оплатить в ввыбранной кассе!')
        //   this.credits.pop();
        // }

        if(this.listCashbox){

          console.log('ищем подходящую кассу для оплаты')

          let cresditCashboxes = this.listCashbox.filter(cashboxItem => {
            return this.credits.some(creditItem => cashboxItem.inn === creditItem.org.org_inn);
          });

          if(cresditCashboxes) {

            console.log('нашли кассу')

            this.sale.org = cresditCashboxes;
            this.listCreditCashbox = cresditCashboxes

          } else {

            alert('Нет подходящих касс для оплаты!')

          }

          
        } else {
          alert('Нет подходящих касс!')
        }


      } else {
        alert('Нет подходящих касс!')
        this.credits.pop();
      }
      
     

    },
    cashbox(){
      console.log('cashbox change')
      //setItem('select_org-sale',JSON.stringify(this.sale.org))
      this.setCashboxTerminal()
    },
    cashbox_debit(){
      console.log('cashbox debit change')
      //setItem('select_org-sale',JSON.stringify(this.sale.org))
      this.setCashboxTerminal()
    },
    main_bill_part_def(){
      if(this.main_bill_part && this.main_bill_part !== null){
        //уже выбран один
        console.log('уже есть один')
        
        if(this.main_bill_part_def !== null){

          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part2 = this.main_bill_part_def
          }

          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part2.deposit_id){
              this.main_bill_part2 = null
            }
            
            return;
          }
          if(+this.main_bill_part2.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted2 = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)

            this.summ_bill_part_pre2 = 0

          } else {
            this.bill_part_setted2 = false
          }
        }

      } else {

        if(this.main_bill_part_def !== null){
          
          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part = this.main_bill_part_def
          }
          
          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part.deposit_id){
              this.main_bill_part = null
            }
            return;
          }
          if(+this.main_bill_part.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)

            this.summ_bill_part_pre = 0

          } else {
            this.bill_part_setted = false
          }
        }

      }
    },
    main_bonus_part(){

      console.log(this.cash_in_part_pre)
      console.log(this.cash_in_part)
      console.log(this.summ_bonus_part_pre)
      console.log(this.main_bonus_part)

      if(this.credits.length > 1){
        alert('Если вы хотите применить бонусы, то оплату надо провести за каждый долг отдельно');
        return;
      }

      if(+this.main_bonus_part.deposit_balance <= 0){
        this.bonus_part_setted = true

        this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)

        this.summ_bonus_part_pre = this.main_bonus_part

        console.log('bb1')

      } else {

        console.log('bb')

        this.bonus_part_setted = false

        this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit ?this.main_bonus_part.bonus_limit : 0
      }

      

    },
    cash_in() {
      this.cash_out = this.cash_in > this.summ ? (this.cash_in - this.summ) : 0;
    },
    'sale.org'() {
      console.log(this.sale.org)
      setItem('select_org-sale',JSON.stringify(this.sale.org))
      if(+this.term_i === 0){
        this.term_i = 1
      } else {
        this.term_i = 0
      }
      this.setCashboxTerminal()
    },
    summ_cash_part(){
      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_card_part = this.summ_part - this.summ_cash_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    summ_card_part(){

      if(this.dialogTypeOfPaymentPart.includes(0) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_cash_part = this.summ_part - this.summ_card_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    cash_in_part() {

      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      } else {
        this.cash_out_part = this.cash_in_part > this.summ_cash_part ? (this.cash_in_part - this.summ_cash_part) : 0;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.v-data-table-header th {
  background-color: #F1F1F1 !important;
  color: #1A1A1A !important;
  border-left: 1px solid #E0E0E0;
}

.client-card {
  margin-top: 20px;
}

.client-card:first-child {
  margin-top: 0;
}

.card-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1A1A1A;
}

.card-edit__subtitle {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #767676;
  margin-top: 20px;
  margin-bottom: 10px;
}

.logo-card {
  position: relative;
  padding-left: 22px;
}

.logo-card:before {
  position: absolute;
  content: '';
  width: 14px;
  height: 13px;
  left: 0;
  top: calc(50% - 6px);
  display: inline-block;
  background: url("/playground_assets/mediumcreditcard3282-ogu.svg") bottom;
  background-size: cover;
}

.edit-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}

.add-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}

.user-phone {
  position: relative;
  padding-left: 22px;
  padding-top: 20px;
}

.user-phone:before {
  position: absolute;
  content: '';
  width: 14px;
  height: 14px;
  left: 0;
  top: 26px;
  display: inline-block;
  background: url("/playground_assets/mediumphone3282-ms4e.svg") bottom;
  background-size: cover;
}

.user-email {
  position: relative;
  padding-left: 22px;
  padding-top: 20px;
}

.user-email:before {
  position: absolute;
  content: '';
  width: 14px;
  height: 13px;
  left: 0;
  top: 26px;
  display: inline-block;
  /*  background: url("/playground_assets/mediummail3282-re9.svg") bottom;*/
  background-size: cover;
}

.user-position {
  position: relative;
  padding-left: 22px;
  padding-top: 20px;
}

.user-position:before {
  position: absolute;
  content: '';
  width: 14px;
  height: 13px;
  left: 0;
  top: 26px;
  display: inline-block;
  background: url("/playground_assets/mediumuser3282-vh88.svg") bottom;
  background-size: cover;
}

.theme--light.v-card > .v-card__text, .theme--light.v-card > .v-card__subtitle {
  color: #000 !important;
}

.edit-avatar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.user-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 0;
  width: 100px;
  height: 100px;
  border-radius: 145px;
  background-color: #F1F1F1;
}

.debt-title {
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
}

.debt-subtitle {
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: #767676;
}

.custom__table {
  margin-left: -20px;
  max-width: 106% !important;
  width: 106% !important;
}

.custom__menu {
  // max-height: 112px !important;
  max-width: 218px !important;
}

.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}

.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}

.dots-button__actions {
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}

.dots-button__actions[aria-expanded="true"] {
  background: #629F33;
  outline: 4px solid #E0ECD6;
}

.dots-button__actions[aria-expanded="true"] > .v-btn__content .v-icon {
  color: #fff;
}

.dots-button__actions:hover {
  background: #629F33;
}

.dots-button__actions:hover > .v-btn__content .v-icon {
  color: #fff;
}

#horizontal_tabs > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  border-radius: 12px !important;
}

#horizontal_tabs > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: center !important;
}

.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0 !important;
}

#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-item-group.theme--light.v-btn-toggle.v-btn-toggle--rounded > button.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  color: #629F33 !important;
}


#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-input.v-input--hide-details.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted {
  height: 35px !important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: white !important;
  border-bottom: none !important;
}

#inspire > div > main > div > div > div > div:nth-child(3) > div > div.v-card__title > div.v-input.v-input--hide-details.v-input--dense.theme--light.v-text-field.v-text-field--single-line.v-text-field--solo.v-text-field--solo-inverted.v-text-field--solo-flat.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--rounded > div > div {
  background: #fff !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.menu-bottom-label {
  height: 30px;
  display: flex;
  margin-top: 30px;
  box-sizing: border-box;
  align-items: flex-start;
  flex-shrink: 0;
  border-color: transparent;
  border-radius: 0px 0px 0px 0px;
}

.block {
  background: #fff;

  &.padding-20 {
    padding: 20px;
  }

  &:not(:last-child) {
    margin-bottom: 20px;

  }

  &.margin-bottom-10 {
    margin-bottom: 10px;
  }

  button.gray {
    background: #F1F1F1;
    border-radius: 12px;
    text-transform: none;
    color: #1A1A1A;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    border: none;
    width: 100%;
    box-shadow: unset;
  }
}

.client-info {
  .personal-info {

    .item {
      width: 100%;
      font-family: 'Circe';
      font-weight: 400;
      font-style: normal;

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &__grid {
        display: grid;
        grid-template-columns: 1fr 63px;
      }

      &__head {
        color: #1A1A1A;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 14px;

        .right {
          &.buttons-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          &.justify-flex-end {
            display: flex;
            justify-content: flex-end;
          }

          button.gray {
            padding: 4px 8px;
            border-radius: 25px;
            font-size: 13px;
            line-height: 16px;
            color: #1A1A1A;
            height: 24px !important;
          }
        }
      }

      &__value {
        color: #767676;
        font-size: 13px;
        line-height: 16px;

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .right {
          &.text-right {
            text-align: right;
          }

          &.color-black {
            color: #1A1A1A;
          }
        }
      }

      .btn-icon {
        width: 24px;
        height: 24px;
        background: #F1F1F1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .3s;

        &:hover {
          background: #e0e0e0;
        }
      }
    }
  }
}

.justify-end-bottom {
  margin-right: 0px;
  margin-bottom: 10px;
}

.v-text-field--outlined > fieldset {
  border-color: #E0E0E0;
  font-size: 11px;
}

.v-text-field > input {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: capitalize;
}

.v-text-field > label {
  font-size: 0.8em;
}

.v-text-field > button {
  font-size: 0.8em;
}

.active {
  color: #629F33 !important;
}

.block {
  color: #D53025 !important;
}

.v-input--selection-controls > input {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: capitalize;
}

.v-input--selection-controls > label {
  font-size: 0.8em;
}

.v-input--selection-controls > button {
  font-size: 0.8em;
}

.v-select > input {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: capitalize;
}

.v-select > label {
  font-size: 0.8em;
}

.v-select > button {
  font-size: 0.8em;
}

.red-button {
  background-color: #D53025 !important;
}

.purpure-button {
  background-color: #A13453 !important;
}

.white-button-text {
  color: #fff !important;
}

.v-tabs.theme--light {
  border-radius: 20px !important;
  width: 98% !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  justify-content: start !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #E0ECD6 !important;
  border-radius: 0 !important;
  color: #629F33 !important;
  height: 40px !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: start !important;
  text-transform: none !important;
  text-align: left !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #767676 !important;
  height: 40px !important;
  padding: 8px 12px !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.payment-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px !important;
  color: #767676 !important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 13px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  margin-top: 10px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.scroll-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
  scrollbar-width: thin;
  scrollbar-color: #E0E0E0 #fff;
  border-bottom: 1px solid #E0E0E0;

  &::-webkit-scrollbar {
    height: 12px;
    background: #E0E0E0;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #E0E0E0;
    border-radius: 8px;
    border: 2px solid #fff;
  }

  table {
    border-collapse: collapse;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    min-width: 100%;

    &#table-3 {
      min-width: 100%;

      .td-check {
        div {
          display: flex;
          align-items: center;

          svg {
            margin-right: 10px;
          }
        }
      }

      .td-client {
        div {
          white-space: nowrap;
          display: flex;
          align-items: center;

          .ava {
            width: 24px;
            min-width: 24px;
            max-width: 24px;
            height: 24px;
            min-height: 24px;
            max-height: 24px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 8px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
      }
    }

    &#table-4 {
      width: 100%;
    }

    th {
      vertical-align: top;
    }

    th,
    td {
      background: #fff;
      padding: 10px 12px;
      text-align: left;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      color: #000000;
      border: 1px solid #E0E0E0 !important;

      &.font-bold {
        font-weight: bold;
      }

      &.no-wrap {
        white-space: nowrap;
      }

      &:first-child {
        border-left: 0 !important;
      }

      &:last-child {
        border-left: 0 !important;
      }

      .open-hide {
        border: 1px solid #1A1A1A;
        width: 12px;
        height: 12px;
        display: flex;
        justify-content: center;
        border-radius: 2px;

        &::after {
          content: "+";
          line-height: 12px;
        }

        &.open {
          align-items: center;

          &::after {
            content: "";
            display: block;
            height: 1px;
            background: #1A1A1A;
            width: 6px;
            border-radius: 1px;
            line-height: 10px;
          }
        }
      }
    }

    tbody {
      tr {
        &.parrent {
          td {
            background: #ffffff;
          }
        }

        &:last-child {
          td {
            border-bottom: 1 !important;
          }
        }
      }
    }
  }
}

.no-bg {
  background-color: #F1F1F1 !important;
}

.filtere {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      flex: 1;
      display: flex;
      align-items: center;

      .v-input__slot {
        border-radius: 12px;
      }
    }

    .right {
      .v-input__slot {
        border-radius: 12px;
      }

      .toggle-label {
        display: block;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: right;
        width: 100%;
        color: #767676;
      }

      .v-btn-toggle {
        button {
          &:first-child {
            border-radius: 12px 0 0 12px;
          }

          &:last-child {
            border-radius: 0 12px 12px 0;
          }

          background: #fff !important;

          &::before {
            display: none;
          }
        }
      }
    }

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.sho_item:hover{
  background: #eee;
  transition: 0.5s;
  display: flex;
  align-items: center;
  height: 30px;
}

</style>